var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplication1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2126 1492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-18{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#91b3fa;}.cls-4{fill:#bdd0fb;}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:#7d97f4;}.cls-10{fill:#18174a;}.cls-11{fill:#2b69b3;}.cls-12{fill:url(#linear-gradient-6);}.cls-13{opacity:0.73;}.cls-14{opacity:0.7;}.cls-15{opacity:0.77;}.cls-16{clip-path:url(#clip-path);}.cls-17{clip-path:url(#clip-path-2);}.cls-18{opacity:0.81;}.cls-19{fill:url(#linear-gradient-7);}.cls-20{fill:url(#linear-gradient-8);}.cls-21{fill:url(#linear-gradient-9);}.cls-22{opacity:0.64;}.cls-23{fill:url(#linear-gradient-10);}.cls-24{fill:url(#linear-gradient-11);}.cls-25{fill:url(#linear-gradient-12);}.cls-26{fill:url(#linear-gradient-13);}.cls-27{fill:url(#linear-gradient-14);}.cls-28{fill:url(#linear-gradient-15);}.cls-29{fill:url(#linear-gradient-16);}.cls-30{fill:url(#linear-gradient-17);}.cls-31{fill:url(#linear-gradient-18);}.cls-32{fill:url(#linear-gradient-19);}.cls-33{fill:url(#linear-gradient-20);}.cls-34{fill:url(#linear-gradient-21);}.cls-35{fill:url(#linear-gradient-22);}.cls-36{fill:url(#linear-gradient-23);}.cls-37{fill:url(#linear-gradient-24);}.cls-38{fill:url(#linear-gradient-25);}.cls-39{fill:url(#linear-gradient-26);}.cls-40{fill:url(#linear-gradient-27);}.cls-41{fill:url(#linear-gradient-28);}.cls-42{fill:url(#linear-gradient-29);}.cls-43{fill:url(#linear-gradient-30);}.cls-44{fill:url(#linear-gradient-31);}.cls-45{fill:url(#linear-gradient-32);}.cls-46{fill:url(#linear-gradient-33);}.cls-47{fill:url(#linear-gradient-34);}.cls-48{fill:url(#linear-gradient-35);}.cls-49{fill:url(#linear-gradient-36);}.cls-50{fill:url(#linear-gradient-37);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 12.33,
    y1: 752.25,
    x2: 2110,
    y2: 752.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1353.93,
    y1: 1216.95,
    x2: 2042.56,
    y2: 1216.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1427.39,
    y1: 1382.88,
    x2: 1422.24,
    y2: 1396.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a737d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef497a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 209.15,
    y1: 1055.06,
    x2: 751.25,
    y2: 1055.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 230.71,
    y1: 487.44,
    x2: 651.05,
    y2: 487.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 621.66,
    y1: 1021.76,
    x2: 1686.77,
    y2: 106.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "773.44 479.67 785.24 468.41 796.49 480.21 796.72 470.43 785.47 458.63 773.67 469.88 773.44 479.67"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1280.62 772.08 1292.29 760.69 1280.9 749.02 1290.68 749.14 1302.08 760.8 1290.41 772.19 1280.62 772.08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1438.98,
    y1: 652.39,
    x2: 1450.31,
    y2: 471.06,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1519.32,
    y1: 657.42,
    x2: 1530.65,
    y2: 476.08,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1610.47,
    y1: 663.11,
    x2: 1621.8,
    y2: 481.78,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 5470.96,
    y1: 1420.74,
    x2: 5492.87,
    y2: 1420.74,
    gradientTransform: "translate(-4984.22 -55.83) rotate(0.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 5391.99,
    y1: 1419.61,
    x2: 5410.91,
    y2: 1419.61,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 552.84,
    y1: 909.84,
    x2: 696.17,
    y2: 796.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 753.69,
    y1: 662.87,
    x2: 730.36,
    y2: 697.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 692.94,
    y1: 681.93,
    x2: 678.94,
    y2: 802.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 5316.19,
    y1: 1007.65,
    x2: 5457.86,
    y2: 1007.65,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 483.72,
    y1: 778.92,
    x2: 453.05,
    y2: 887.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -2162.2,
    y1: 46.59,
    x2: -2138.2,
    y2: 139.93,
    gradientTransform: "matrix(0.75, -0.66, 0.66, 0.75, 672.22, -1616.26)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -2182.31,
    y1: 51.77,
    x2: -2158.31,
    y2: 145.1,
    gradientTransform: "matrix(0.75, -0.66, 0.66, 0.75, 672.22, -1616.26)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 696.91,
    y1: 1329.6,
    x2: 793.44,
    y2: 1329.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 680.42,
    y1: 1143.69,
    x2: 682.42,
    y2: 1231.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 776.27,
    y1: 957.78,
    x2: 831.61,
    y2: 1051.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -1276.64,
    y1: 159.59,
    x2: -1279.3,
    y2: 252.92,
    gradientTransform: "translate(-1934.69 -2842.96) rotate(-52.83)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -1250.58,
    y1: 163.62,
    x2: -1253.25,
    y2: 256.95,
    gradientTransform: "translate(-1934.69 -2842.96) rotate(-52.83)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 897.49,
    y1: 1043.96,
    x2: 869.49,
    y2: 1117.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 639.32,
    y1: 1125.48,
    x2: 561.32,
    y2: 1240.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2009,
    y1: 1376.48,
    x2: 2078.17,
    y2: 1376.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1972.13,
    y1: 1223.64,
    x2: 2091.42,
    y2: 1223.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1977.36,
    y1: 1178.59,
    x2: 2083.6,
    y2: 1178.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1985.67,
    y1: 1223.3,
    x2: 2083.6,
    y2: 1223.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1988.09,
    y1: 1262.54,
    x2: 2084.87,
    y2: 1262.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1298.32,
    y1: 1383.62,
    x2: 1367.49,
    y2: 1383.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1285.07,
    y1: 1230.79,
    x2: 1404.36,
    y2: 1230.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1292.88,
    y1: 1185.74,
    x2: 1399.13,
    y2: 1185.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1292.88,
    y1: 1230.44,
    x2: 1390.82,
    y2: 1230.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1291.62,
    y1: 1269.68,
    x2: 1388.4,
    y2: 1269.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1782.78,
    y1: 218.77,
    x2: 1859.51,
    y2: 218.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1864.65,
    y1: 202.57,
    x2: 1941.41,
    y2: 202.57,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2050.65,820.12c-36.37-38.38-79.38-75.81-90.6-127.92-19.41-90.17,63.58-167.06,90.75-255.13,18.78-60.89,9.09-130.22-25.63-183.36s-93.77-89-156.16-94.81c-107.36-10-212.42,63.66-318.17,42.32-84.67-17.09-151.58-92.48-237.53-100.56-101.15-9.5-185.07,75.56-281.65,107.59-115.53,38.31-240.79-1.73-354.37-45.66S444.2,69.64,324.48,90.67C191.21,114.07,79.47,232.38,61.64,369,44,504.31,192.13,613,66,775.48,26.61,826.27.39,897,17.81,959.24c16.93,60.5,89,98.76,89.49,161.66.42,49.66-45.54,89.17-49.24,138.69-3.18,42.5,26.82,81.79,63.69,101.94s79.66,25.06,121.26,29.63h0a9,9,0,0,0,5.89,15c203.55,17.31,408.28,13.17,612.53,9L1856.47,1395c34.09-.7,69-1.55,100.77-14.18s60.25-39.66,65.09-74c8.23-58.51-51.81-109.3-46.26-168.14,7.09-75.14,110.94-104.13,130.7-176.88C2120.74,910.28,2087,858.5,2050.65,820.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M328.33,114.36a2.27,2.27,0,0,1-1.8-3.63c1.82-2.41,3.72-4.83,5.65-7.19a2.27,2.27,0,1,1,3.51,2.87c-1.89,2.31-3.76,4.69-5.55,7A2.25,2.25,0,0,1,328.33,114.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M752,211.39a2.26,2.26,0,0,1-2.22-1.82c-1.2-6-2.65-12-4.32-17.94a2.27,2.27,0,0,1,4.37-1.24c1.7,6,3.18,12.17,4.4,18.29a2.25,2.25,0,0,1-2.23,2.71Zm-14.44-46.65a2.27,2.27,0,0,1-2.08-1.38c-2.41-5.64-5.07-11.25-7.91-16.68a2.27,2.27,0,0,1,4-2.1c2.89,5.54,5.61,11.25,8.06,17a2.27,2.27,0,0,1-1.2,3A2.16,2.16,0,0,1,737.58,164.74ZM713.92,122a2.28,2.28,0,0,1-1.87-1c-3.5-5-7.24-10-11.1-14.74a2.27,2.27,0,1,1,3.51-2.87c3.94,4.83,7.75,9.88,11.32,15a2.27,2.27,0,0,1-.57,3.16A2.3,2.3,0,0,1,713.92,122ZM354.56,85.08A2.26,2.26,0,0,1,353,81.17c4.54-4.29,9.3-8.45,14.17-12.38A2.27,2.27,0,1,1,370,72.32c-4.77,3.85-9.44,7.94-13.89,12.14A2.24,2.24,0,0,1,354.56,85.08ZM682.11,85a2.29,2.29,0,0,1-1.56-.62c-4.45-4.21-9.12-8.3-13.88-12.15a2.26,2.26,0,1,1,2.85-3.52c4.86,3.92,9.61,8.09,14.15,12.38a2.27,2.27,0,0,1,.08,3.2A2.24,2.24,0,0,1,682.11,85ZM393.31,55.33a2.26,2.26,0,0,1-1.19-4.19c5.33-3.3,10.84-6.41,16.37-9.26a2.27,2.27,0,1,1,2.08,4c-5.43,2.8-10.84,5.85-16.07,9.09A2.23,2.23,0,0,1,393.31,55.33Zm250.07-.12a2.32,2.32,0,0,1-1.18-.33c-5.22-3.22-10.63-6.26-16.08-9.05a2.26,2.26,0,1,1,2.06-4c5.56,2.84,11.07,5.94,16.39,9.21a2.27,2.27,0,0,1-1.19,4.2ZM437.27,34a2.27,2.27,0,0,1-.78-4.4c5.88-2.13,11.91-4.05,17.93-5.72a2.27,2.27,0,0,1,1.21,4.37C449.72,29.91,443.8,31.8,438,33.9A2.31,2.31,0,0,1,437.27,34Zm162.12,0a2.28,2.28,0,0,1-.77-.14c-5.76-2.08-11.68-4-17.59-5.58a2.27,2.27,0,1,1,1.2-4.37c6,1.65,12,3.57,17.93,5.69a2.27,2.27,0,0,1-.77,4.4ZM552,22.22l-.32,0c-6.07-.87-12.25-1.51-18.36-1.9a2.26,2.26,0,1,1,.29-4.52c6.23.4,12.53,1,18.71,1.93a2.27,2.27,0,0,1-.32,4.51Zm-67.35,0a2.27,2.27,0,0,1-.31-4.51c6.17-.88,12.47-1.53,18.71-1.92a2.26,2.26,0,1,1,.29,4.52c-6.13.39-12.31,1-18.37,1.88A1.66,1.66,0,0,1,484.65,22.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M756.49,250.55a2.27,2.27,0,0,1-2.27-2.2c-.09-3-.24-6-.44-9a2.27,2.27,0,1,1,4.52-.31c.21,3,.36,6.1.46,9.13a2.28,2.28,0,0,1-2.2,2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M689.44,423.84a2.27,2.27,0,0,1-1.63-3.84c2.09-2.15,4.15-4.36,6.13-6.56a2.27,2.27,0,1,1,3.37,3c-2,2.24-4.11,4.49-6.24,6.68A2.27,2.27,0,0,1,689.44,423.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M518.62,496.23h-2a2.27,2.27,0,0,1,0-4.54h2c5.36,0,10.79-.18,16.14-.55a2.3,2.3,0,0,1,2.42,2.11,2.26,2.26,0,0,1-2.11,2.41C529.62,496,524.08,496.23,518.62,496.23Zm-31.73-2.12-.31,0c-6.09-.82-12.22-1.88-18.23-3.16a2.26,2.26,0,1,1,.94-4.43c5.9,1.25,11.92,2.29,17.89,3.1a2.26,2.26,0,0,1-.29,4.51Zm77.55-2.34a2.27,2.27,0,0,1-.43-4.49c5.92-1.17,11.87-2.58,17.67-4.2a2.27,2.27,0,0,1,1.22,4.37c-5.92,1.65-12,3.09-18,4.28A2.12,2.12,0,0,1,564.44,491.77ZM440.13,483a2.45,2.45,0,0,1-.75-.12c-5.8-2-11.6-4.28-17.23-6.74A2.26,2.26,0,1,1,424,472c5.53,2.4,11.22,4.63,16.91,6.6a2.27,2.27,0,0,1-.74,4.41Zm170.29-5.24a2.26,2.26,0,0,1-.88-4.35c5.56-2.34,11.1-4.92,16.46-7.68a2.27,2.27,0,0,1,2.08,4c-5.48,2.81-11.12,5.45-16.78,7.83A2.29,2.29,0,0,1,610.42,477.74Zm-213.87-15a2.21,2.21,0,0,1-1.16-.32c-5.28-3.13-10.5-6.52-15.53-10.05a2.27,2.27,0,1,1,2.61-3.71c4.93,3.47,10.06,6.79,15.24,9.87a2.26,2.26,0,0,1-1.16,4.21Zm256.09-8a2.27,2.27,0,0,1-1.27-4.14c5-3.4,9.9-7,14.6-10.79a2.27,2.27,0,1,1,2.83,3.54c-4.78,3.83-9.79,7.53-14.88,11A2.32,2.32,0,0,1,652.64,454.76Zm-294.7-20.63a2.23,2.23,0,0,1-1.52-.6c-4.54-4.14-9-8.51-13.18-13a2.26,2.26,0,0,1,3.3-3.1c4.13,4.39,8.48,8.68,12.93,12.74a2.27,2.27,0,0,1-1.53,3.95Zm-32-35.82a2.28,2.28,0,0,1-1.84-.93c-2.84-3.91-5.61-8-8.23-12.06-.7-1.1-1.4-2.21-2.08-3.32a2.27,2.27,0,1,1,3.86-2.38c.67,1.09,1.35,2.17,2,3.26,2.57,4,5.29,8,8.08,11.83a2.26,2.26,0,0,1-1.83,3.6Zm-24.27-41.49a2.26,2.26,0,0,1-2.06-1.33c-2.56-5.59-4.93-11.35-7.05-17.12a2.27,2.27,0,1,1,4.26-1.56c2.08,5.66,4.4,11.31,6.91,16.8a2.26,2.26,0,0,1-1.12,3A2.22,2.22,0,0,1,301.64,356.82Zm-15.46-45.51a2.26,2.26,0,0,1-2.2-1.76c-1.38-6-2.53-12.11-3.44-18.2a2.26,2.26,0,1,1,4.48-.66c.89,6,2,12,3.37,17.84a2.27,2.27,0,0,1-1.7,2.72A2.22,2.22,0,0,1,286.18,311.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M280.24,263.52A2.27,2.27,0,0,1,278,261.3c-.07-3.06-.08-6.14,0-9.15a2.27,2.27,0,0,1,2.27-2.23h0a2.26,2.26,0,0,1,2.23,2.3c0,3,0,6,0,9a2.25,2.25,0,0,1-2.22,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M337.25,230a2.86,2.86,0,0,0,1.2,3.1l29.1,19.07a151.56,151.56,0,0,0,7.05,48.6L352.16,327.3a2.83,2.83,0,0,0-.27,3.3l21.35,35.86a2.86,2.86,0,0,0,3,1.33l34-7.08a151.65,151.65,0,0,0,39.37,29.35l2.92,34.67a2.86,2.86,0,0,0,2.14,2.53l40.46,10.25a2.85,2.85,0,0,0,3.09-1.2l19.07-29.1a151.56,151.56,0,0,0,48.6-7l26.56,22.44a2.85,2.85,0,0,0,3.31.27l35.85-21.35a2.86,2.86,0,0,0,1.34-3l-7.09-34a151.65,151.65,0,0,0,29.35-39.37L690,322.15a2.85,2.85,0,0,0,2.53-2.14l10.26-40.46a2.86,2.86,0,0,0-1.21-3.09l-29.1-19.07a151.28,151.28,0,0,0-7.05-48.6l22.44-26.56a2.86,2.86,0,0,0,.28-3.31l-21.36-35.85a2.85,2.85,0,0,0-3-1.34l-34,7.09a151.48,151.48,0,0,0-39.37-29.35L587.39,84.8a2.86,2.86,0,0,0-2.15-2.53L544.79,72a2.87,2.87,0,0,0-3.1,1.21l-19.07,29.09a151.57,151.57,0,0,0-48.6,7.06L447.46,86.93a2.85,2.85,0,0,0-3.3-.28L408.3,108a2.85,2.85,0,0,0-1.33,3l7.08,34a151.48,151.48,0,0,0-29.35,39.37L350,187.37a2.86,2.86,0,0,0-2.53,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M520,295.2a40.31,40.31,0,0,1-28.64-11.86h0a40.46,40.46,0,0,1,28.64-69h0a40.45,40.45,0,1,1,0,80.89Zm-23.83-16.66A33.47,33.47,0,0,0,520,288.42h0a33.66,33.66,0,0,0,0-67.31h0a33.66,33.66,0,0,0-23.83,57.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M521,359a104.16,104.16,0,0,1-89.61-50.81,105.61,105.61,0,0,1-6.74-13.4l0-.08s0,0,0-.06l0-.05,0,0-.06-.15a.42.42,0,0,0,0-.1l-.06-.15c-.09-.21-.17-.43-.26-.64v0l-.09-.22c-.08-.19-.15-.38-.22-.57a.69.69,0,0,1-.05-.13c-.06-.14-.12-.29-.17-.43-.18-.47-.35-.93-.52-1.39-.07-.18-.14-.37-.2-.55-.14-.37-.27-.74-.4-1.11l-.35-1,6.45-2.17a97.9,97.9,0,0,0,8.66,18.82c.06.09.11.18.16.27a97.49,97.49,0,0,0,101.7,45.52l.13,0h0l.09,0a97,97,0,0,0,29.45-10.87l1.83-1.06A97.3,97.3,0,1,0,435.21,208.72l-6-3.22A104.13,104.13,0,1,1,521,359Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107,340a2.27,2.27,0,0,1-1.8-3.63c1.84-2.44,3.79-4.85,5.79-7.17a2.27,2.27,0,0,1,3.43,3c-1.94,2.24-3.82,4.57-5.6,6.93A2.28,2.28,0,0,1,107,340Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M354.14,381.45a2.27,2.27,0,0,1-2.16-1.56,136.94,136.94,0,0,0-7-17.31,2.27,2.27,0,0,1,4.08-2,143.65,143.65,0,0,1,7.21,17.88,2.28,2.28,0,0,1-1.46,2.86A2.13,2.13,0,0,1,354.14,381.45Zm-23.39-43.71a2.27,2.27,0,0,1-1.79-.86A138,138,0,0,0,316.47,323a2.27,2.27,0,0,1,3.16-3.25,141.34,141.34,0,0,1,12.9,14.32,2.27,2.27,0,0,1-.38,3.18A2.24,2.24,0,0,1,330.75,337.74Zm-195.51-25.8a2.27,2.27,0,0,1-1.36-4.08c2.75-2.05,5.61-4,8.51-5.88,2.5-1.6,5.08-3.14,7.68-4.59a2.27,2.27,0,0,1,2.21,4c-2.52,1.39-5,2.89-7.45,4.44-2.8,1.79-5.58,3.71-8.24,5.69A2.26,2.26,0,0,1,135.24,311.94Zm158.5-7.16a2.32,2.32,0,0,1-1.18-.33A138.1,138.1,0,0,0,276,295.78a2.27,2.27,0,0,1,1.83-4.15,143.44,143.44,0,0,1,17.06,8.95,2.27,2.27,0,0,1-1.19,4.2Zm-114.2-15.09a2.27,2.27,0,0,1-.64-4.44A143.89,143.89,0,0,1,197.7,281a2.27,2.27,0,0,1,.7,4.48,138.5,138.5,0,0,0-18.21,4.1A2.43,2.43,0,0,1,179.54,289.69Zm68.07-3a2.28,2.28,0,0,1-.45,0,140.69,140.69,0,0,0-18.5-2.45,2.27,2.27,0,0,1-2.12-2.41,2.3,2.3,0,0,1,2.41-2.12,144.92,144.92,0,0,1,19.11,2.54,2.26,2.26,0,0,1-.45,4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M361,420.75a2.26,2.26,0,0,1-2.26-2.19c-.09-3-.28-6-.56-8.9a2.27,2.27,0,0,1,4.52-.43c.28,3,.48,6.13.57,9.19a2.25,2.25,0,0,1-2.2,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M318.61,526.17a2.27,2.27,0,0,1-1.58-3.89c2.12-2.07,4.2-4.23,6.17-6.43a2.27,2.27,0,0,1,3.38,3c-2.05,2.27-4.19,4.51-6.38,6.65A2.27,2.27,0,0,1,318.61,526.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.19,566.05a2.27,2.27,0,0,1-.18-4.53,138.75,138.75,0,0,0,18.16-2.68,2.27,2.27,0,1,1,1,4.43A142.85,142.85,0,0,1,231.37,566Zm-30.27-.82-.3,0A144.92,144.92,0,0,1,182,561.44a2.26,2.26,0,1,1,1.19-4.37,139.47,139.47,0,0,0,18,3.64,2.27,2.27,0,0,1-.3,4.52Zm77.47-11.47a2.27,2.27,0,0,1-.95-4.33,140,140,0,0,0,16.16-8.72,2.27,2.27,0,1,1,2.41,3.84,143.55,143.55,0,0,1-16.68,9A2.14,2.14,0,0,1,278.39,553.76Zm-124-3.25a2.21,2.21,0,0,1-1.05-.26,144.43,144.43,0,0,1-16.2-9.84,2.27,2.27,0,0,1,2.61-3.71,138.33,138.33,0,0,0,15.69,9.53,2.27,2.27,0,0,1-1,4.28Zm-38.7-29.66a2.26,2.26,0,0,1-1.67-.73,144.32,144.32,0,0,1-11.87-14.78,2.27,2.27,0,0,1,3.72-2.6,138.92,138.92,0,0,0,11.49,14.31,2.27,2.27,0,0,1-1.67,3.8ZM89.4,479.8a2.29,2.29,0,0,1-2.09-1.39,144.28,144.28,0,0,1-6.17-17.93,2.27,2.27,0,0,1,4.38-1.19,136.79,136.79,0,0,0,6,17.36,2.27,2.27,0,0,1-2.09,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.59,432.13A2.26,2.26,0,0,1,76.33,430c-.15-3.05-.2-6.15-.15-9.2a2.27,2.27,0,0,1,2.27-2.23h0a2.27,2.27,0,0,1,2.23,2.3c0,3,0,6,.14,8.92a2.26,2.26,0,0,1-2.15,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.28,407.63a1.68,1.68,0,0,0,.72,1.83l17.26,11.32a89.78,89.78,0,0,0,4.18,28.83l-13.31,15.75a1.69,1.69,0,0,0-.16,2l12.67,21.27a1.69,1.69,0,0,0,1.8.8l20.19-4.2A90,90,0,0,0,179,502.6l1.73,20.56a1.7,1.7,0,0,0,1.27,1.51l24,6.08a1.7,1.7,0,0,0,1.84-.72l11.31-17.26A89.74,89.74,0,0,0,248,508.59l15.76,13.31a1.69,1.69,0,0,0,2,.16L287,509.39a1.69,1.69,0,0,0,.79-1.8l-4.2-20.19A90,90,0,0,0,301,464l20.57-1.73A1.69,1.69,0,0,0,323,461l6.08-24a1.71,1.71,0,0,0-.71-1.84l-17.26-11.31A90,90,0,0,0,307,395.06l13.32-15.76a1.7,1.7,0,0,0,.16-2l-12.67-21.27a1.69,1.69,0,0,0-1.8-.79l-20.2,4.2a90,90,0,0,0-23.36-17.41l-1.72-20.57a1.7,1.7,0,0,0-1.28-1.5l-24-6.08a1.69,1.69,0,0,0-1.83.71l-11.32,17.26a90.07,90.07,0,0,0-28.83,4.19l-15.75-13.32a1.7,1.7,0,0,0-2-.16l-21.27,12.67a1.7,1.7,0,0,0-.8,1.8l4.2,20.2a90.16,90.16,0,0,0-17.41,23.35l-20.56,1.73a1.72,1.72,0,0,0-1.51,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.7,447.7a25.35,25.35,0,1,1,17.93-7.4A25.3,25.3,0,0,1,220.7,447.7Zm0-43.95a18.59,18.59,0,0,0,0,37.17h0a18.59,18.59,0,0,0,0-37.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M221.33,485.59a63.69,63.69,0,0,1-15.63-2A62.77,62.77,0,0,1,167,454.73l-.59-1a63.33,63.33,0,0,1-4.59-9.94l-.09-.26c-.12-.34-.24-.67-.35-1l6.44-2.17a56.82,56.82,0,0,0,5,10.9h0a56.33,56.33,0,1,0-1.19-55.57l-6-3.23a63.13,63.13,0,1,1,55.7,93.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M807.09,97.09a2.31,2.31,0,0,1-1.36-.45,2.27,2.27,0,0,1-.44-3.18c1.85-2.45,3.84-4.86,5.92-7.13a2.27,2.27,0,0,1,3.35,3c-2,2.18-3.89,4.47-5.66,6.81A2.25,2.25,0,0,1,807.09,97.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M978,115.88a2.28,2.28,0,0,1-2.07-1.33,97.93,97.93,0,0,0-6.58-12.06q-1.26-2-2.6-3.86a2.27,2.27,0,1,1,3.7-2.62c.93,1.31,1.84,2.66,2.72,4a104.41,104.41,0,0,1,6.89,12.62,2.28,2.28,0,0,1-2.06,3.22ZM947.45,77.67a2.26,2.26,0,0,1-1.37-.46,97.54,97.54,0,0,0-15.63-9.66,2.27,2.27,0,0,1,2-4.07A102.22,102.22,0,0,1,948.82,73.6a2.26,2.26,0,0,1-1.37,4.07ZM836.61,71a2.27,2.27,0,0,1-1.15-4.22,103.77,103.77,0,0,1,17.45-8.1,2.27,2.27,0,1,1,1.51,4.28,98.36,98.36,0,0,0-16.67,7.73A2.25,2.25,0,0,1,836.61,71Zm65.79-12.4-.35,0a102,102,0,0,0-15.27-1.18c-1,0-2,0-3.08,0a2.24,2.24,0,0,1-2.34-2.19,2.26,2.26,0,0,1,2.19-2.34c1.11,0,2.2-.05,3.33-.06a103,103,0,0,1,15.87,1.24,2.26,2.26,0,0,1-.35,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M987,154.33a2.27,2.27,0,0,1-2.27-2.2c-.09-2.94-.31-5.91-.67-8.83a2.27,2.27,0,0,1,4.5-.55c.38,3.06.61,6.17.71,9.25a2.27,2.27,0,0,1-2.2,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M955.1,230.84a2.27,2.27,0,0,1-1.54-3.93c2.16-2,4.25-4.12,6.22-6.31a2.27,2.27,0,1,1,3.37,3c-2.06,2.29-4.25,4.51-6.51,6.6A2.25,2.25,0,0,1,955.1,230.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M883.18,257.51h-.09A103.79,103.79,0,0,1,864.35,255a2.27,2.27,0,0,1,1-4.42A98.3,98.3,0,0,0,883.27,253a2.27,2.27,0,0,1-.09,4.53ZM913,254.17a2.27,2.27,0,0,1-.59-4.46,96.91,96.91,0,0,0,16.94-6.3,2.27,2.27,0,0,1,2,4.09,102.93,102.93,0,0,1-17.73,6.59A2.39,2.39,0,0,1,913,254.17Zm-76.05-10a2.33,2.33,0,0,1-1.13-.3A103,103,0,0,1,820.35,233a2.27,2.27,0,0,1,2.95-3.45A97.14,97.14,0,0,0,838.06,240a2.27,2.27,0,0,1-1.14,4.23ZM802.26,210.8a2.27,2.27,0,0,1-1.92-1.05,103.58,103.58,0,0,1-8.57-16.86,2.26,2.26,0,0,1,4.21-1.67,99.65,99.65,0,0,0,8.2,16.11,2.28,2.28,0,0,1-.71,3.13A2.34,2.34,0,0,1,802.26,210.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M787.13,165a2.26,2.26,0,0,1-2.25-2.1c-.23-3.07-.33-6.19-.28-9.26a2.27,2.27,0,0,1,2.27-2.23h0a2.27,2.27,0,0,1,2.23,2.3c0,2.94,0,5.92.26,8.85a2.27,2.27,0,0,1-2.1,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M810.84,144.37a1.2,1.2,0,0,0,.5,1.3l12.23,8a63.67,63.67,0,0,0,3,20.42l-9.43,11.16a1.21,1.21,0,0,0-.12,1.39l9,15.07a1.18,1.18,0,0,0,1.27.56l14.31-3a63.5,63.5,0,0,0,16.55,12.33l1.22,14.57a1.23,1.23,0,0,0,.9,1.07l17,4.31a1.21,1.21,0,0,0,1.3-.51l8-12.23a64,64,0,0,0,20.43-3l11.16,9.43a1.21,1.21,0,0,0,1.39.11l15.07-9a1.2,1.2,0,0,0,.56-1.28l-3-14.31a63.66,63.66,0,0,0,12.34-16.54l14.57-1.23a1.18,1.18,0,0,0,1.06-.9l4.31-17a1.19,1.19,0,0,0-.5-1.3l-12.23-8a63.63,63.63,0,0,0-3-20.42l9.44-11.17a1.21,1.21,0,0,0,.11-1.39l-9-15.07a1.2,1.2,0,0,0-1.27-.56l-14.31,3a63.5,63.5,0,0,0-16.55-12.33L916,83.35a1.2,1.2,0,0,0-.9-1.06l-17-4.31a1.22,1.22,0,0,0-1.3.51l-8,12.23a63.68,63.68,0,0,0-20.43,3l-11.16-9.43a1.21,1.21,0,0,0-1.39-.12l-15.07,9a1.21,1.21,0,0,0-.56,1.28l3,14.3a63.93,63.93,0,0,0-12.34,16.55l-14.57,1.23a1.18,1.18,0,0,0-1.06.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M887.65,173.76h0a19,19,0,1,1,13.42-5.54A18.81,18.81,0,0,1,887.63,173.76Zm0-31.14A12.17,12.17,0,0,0,879,163.39h0a12.08,12.08,0,0,0,8.6,3.57h0a12.17,12.17,0,0,0,0-24.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M888.09,200.59a46,46,0,0,1-11.31-1.42,45.42,45.42,0,0,1-28-20.92h0c-.07-.12-.14-.23-.2-.35h0a46.57,46.57,0,0,1-3.74-8.12l-.12-.36,6.44-2.17a39.45,39.45,0,0,0,3.47,7.53,38.67,38.67,0,0,0,21.55,17.14c.77.25,1.54.47,2.33.67a38.91,38.91,0,1,0-24.7-56.21l-6-3.22a45.71,45.71,0,1,1,40.33,67.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2099.79,1088.6c6.61,2.67,12.78-4.67,9.11-10.89-21-35.64-69.63-101.3-142.32-99.36-99.61,2.66-172.89,47.94-268.36,209.52-92.79,157.05-305,211.59-362.35,213a5.53,5.53,0,0,0-5.3,4.74h0a5.56,5.56,0,0,0,5.68,6.46c40.3-2,252-15,358.85-71.68C1807.3,1280.87,1972.08,1036.89,2099.79,1088.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2040.15,1042.21a141.34,141.34,0,0,0-24.32-7.31,177.74,177.74,0,0,0-25.25-3.52c-4.23-.38-8.49-.38-12.73-.49-4.24.1-8.49.09-12.71.46a194.59,194.59,0,0,0-73.25,19.36,254,254,0,0,0-43.21,26.64c-27,20.6-50,46.28-70,73.83-4.91,7-9.65,14-14.5,21.16s-9.56,14.42-14.64,21.44l-7.49,10.6-7.74,10.44c-5.08,7-10.56,13.73-15.87,20.57-11,13.43-22.23,26.64-34.29,39.14a472.72,472.72,0,0,1-38.13,35.52,351.53,351.53,0,0,1-89,53.83c-32.07,13.46-65.76,22.37-99.67,28.87s-68.1,11.21-102.25,15.85a1,1,0,0,1-.3-2c34-5.8,68-11.1,101.62-18.43s66.78-16.4,98.09-30.18a357.45,357.45,0,0,0,86.62-53.87,464.56,464.56,0,0,0,37.26-35.12c11.8-12.38,22.83-25.48,33.58-38.81,5.21-6.8,10.58-13.46,15.57-20.44l7.6-10.37,7.36-10.54c5-7,9.59-14.23,14.38-21.34s9.79-14.34,14.79-21.42c20.59-28,44.16-54.16,72.14-75.25s60.43-36.44,95-42.65a189.1,189.1,0,0,1,26.09-2.77c4.37-.25,8.75-.11,13.12-.07,4.36.23,8.73.38,13.07.9,17.38,1.78,34.52,5.63,50.57,13a1.65,1.65,0,0,1-1.32,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1419.84,1395.38l-1.29-9h1.25c3.35,0,6.75-.23,10.11-.59l4-.43-3.24,2.39c-3.43,2.55-6.5,4.72-9.4,6.64Zm1.24-6.8.43,3.05c1.5-1,3.06-2.11,4.7-3.29Q1423.63,1388.52,1421.08,1388.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2041.78,582.93c-38.65,40.71-94,66.44-148,85.8-70.52,25.32-145.78,45.48-202.13,94.87-58.85,51.59-89.07,128.65-105.8,205.11s-22.15,155.23-42.27,230.86c-19.13,71.94-54.14,143.27-113.6,187.33,50.6-5.4,93.2-46.53,115-93.32,23.24-49.91,28.07-106,36-160.5s20.53-110.82,55.58-153.28c68.76-83.31,196.81-85,284.7-147.81,45.47-32.48,78.22-80.3,101-131.32,15.53-34.77,26.78-71.19,36.63-108C2061.71,582.44,2049.05,575.27,2041.78,582.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M734.52,1418a6.25,6.25,0,0,0,4.41-10c-34.55-43.07-169.79-231-10.73-356.17,180.61-142.17,241.16-172,230.2-304.72-10-120.85-73.5-179.81-142.23-209.08-4.8-2-9.17,3.92-5.74,7.84,29.53,33.75,90.91,116.51,60.73,192.66-39.08,98.61-219,248-236.66,395.93-17.49,146.11,40.39,208.23,94.69,281.19a6,6,0,0,0,5.33,2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.83,398.58a11.13,11.13,0,0,1,7-17.22c21.53-4.05,61.27-15.7,106.23-49.09s154.68-100.62,277-12.64,56.1,344.76-25.81,589.73,140.65,452.08,140.65,452.08l57.54,60.21S547.76,1264,533.86,1045.31,660.05,563.93,505,496.63C356.08,432,294.69,510.67,215.83,398.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.31,714.91c-8.26-.45-11.12-11.2-4.2-15.93,39.61-27.08,123.06-72.05,198.43-34.18,103.31,51.89,157.94,135.56,178.55,352.31,20,210.66,216,372.54,275.53,402.3a6.41,6.41,0,0,1,3.23,7.58h0a6.45,6.45,0,0,1-9.15,4c-41.33-22-257.23-140-341.52-252.16C337.69,1061,284.91,723.56,125.31,714.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M210.77,692.08c20.39.29,40.26,4.73,59.32,11.46,4.8,1.6,9.44,3.61,14.12,5.52,4.59,2.12,9.24,4.13,13.69,6.55a220.67,220.67,0,0,1,25.94,15.78c33.09,23.53,59.53,55.71,78.37,91.47S433,897.75,440.76,937.22c1.75,9.9,3.39,19.89,4.95,29.75s2.81,19.73,4.61,29.52l2.54,14.71,2.87,14.65c1.81,9.79,4.17,19.45,6.3,29.17,4.73,19.31,9.88,38.52,16.18,57.36a540.63,540.63,0,0,0,21.88,55.32,414.15,414.15,0,0,0,64.62,99.37,488.09,488.09,0,0,0,42.09,42.15c14.86,13.23,30.39,25.73,46.24,37.84,31.72,24.2,64.92,46.5,97.79,69.24a1,1,0,0,1-1.06,1.6C733,1407,716.24,1396.11,699.64,1385s-33.12-22.47-49.28-34.31c-32.34-23.6-63.28-49.56-90.25-79.49a408.51,408.51,0,0,1-66.71-100.31,547.91,547.91,0,0,1-22.48-56c-6.48-19-11.78-38.45-16.66-57.94-2.2-9.8-4.63-19.55-6.51-29.41l-3-14.76-2.63-14.82c-1.87-9.86-3.2-19.8-4.79-29.71s-3.1-19.62-4.8-29.4c-7.53-38.89-19-77.23-37.3-112.27a293.4,293.4,0,0,0-32.38-49.38,238.37,238.37,0,0,0-42.7-40.66,238.24,238.24,0,0,0-25-15.81c-4.27-2.48-8.75-4.55-13.18-6.74-4.52-2-9-4.06-13.65-5.74A207,207,0,0,0,240,699.49a164.55,164.55,0,0,0-29.24-4.23h-.11a1.59,1.59,0,0,1,.08-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M232.4,389.87a95.15,95.15,0,0,0,21.17,6.38,119.07,119.07,0,0,0,22,2.12,126.41,126.41,0,0,0,43.22-7.69,152.91,152.91,0,0,0,20.07-9,175.79,175.79,0,0,0,18.59-11.82c2.95-2.2,5.88-4.41,8.73-6.74l8.58-7.26a162,162,0,0,1,18.86-13.39,229.62,229.62,0,0,1,86.1-30.91,172.58,172.58,0,0,1,46.31-.32,143.78,143.78,0,0,1,22.85,5,126.47,126.47,0,0,1,21.64,9.14c3.48,1.82,6.79,3.94,10.1,6.05,3.2,2.28,6.42,4.52,9.41,7.07A123.19,123.19,0,0,1,606.7,355c10.1,11.94,17.87,25.58,23.93,39.75,11.92,28.53,17.26,59,19.37,89.22a450.52,450.52,0,0,1,.83,45.44c-.36,15.13-1.42,30.2-2.89,45.22a901.56,901.56,0,0,1-13.87,89.29,1.4,1.4,0,0,1-2.76-.49c4.45-29.69,8.23-59.46,10.15-89.34.92-14.93,1.67-29.86,1.59-44.79s-.41-29.83-1.79-44.64c-2.71-29.54-8.24-59-19.86-85.94a169.24,169.24,0,0,0-10-19.39,129,129,0,0,0-12.58-17.66,112.46,112.46,0,0,0-15.33-15.14c-2.74-2.33-5.7-4.36-8.62-6.44-3-1.91-6.06-3.85-9.25-5.49a122.59,122.59,0,0,0-19.83-8.36,132.6,132.6,0,0,0-21.11-4.71,162,162,0,0,0-43.55.1,224.49,224.49,0,0,0-82.89,28.4A153.65,153.65,0,0,0,380,362.32l-8.79,7.11c-3,2.35-6.12,4.61-9.27,6.81A183.13,183.13,0,0,1,342.18,388a159.21,159.21,0,0,1-21.3,8.77,131,131,0,0,1-45.39,6.13c-15.28-.75-30.45-4-44.16-11a1.14,1.14,0,0,1,1-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1036.23 1281.51 960.22 1205.84 935.25 1232.16 1036.23 1299.83 1036.23 1281.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1081.57 1281.51 1160.51 1205.84 1184.01 1232.16 1081.57 1299.83 1081.57 1281.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1047.56 1158.7 793.33 1410.05 744.94 1410.05 1047.56 1112.76 1047.56 1158.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M805.56,1421.77l-.27-1.6a9.54,9.54,0,0,0-8.36-7.89L749.14,1407A18.62,18.62,0,0,0,729,1421.11a9.39,9.39,0,0,0,9.28,11.6h57.89a9.44,9.44,0,0,0,7.29-3.29A9.32,9.32,0,0,0,805.56,1421.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1074.76 1158.7 1331.51 1410.05 1379.89 1410.05 1074.76 1112.76 1074.76 1158.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1319.28,1421.77l.27-1.6a9.54,9.54,0,0,1,8.36-7.89l47.78-5.29a18.61,18.61,0,0,1,20.16,14.12,9.35,9.35,0,0,1-1.77,8.06,9.44,9.44,0,0,1-7.5,3.54h-57.89a9.44,9.44,0,0,1-7.29-3.29A9.29,9.29,0,0,1,1319.28,1421.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1036.23,1004.27v296.11c0,5.26,8.28,7.65,13.55,7.65H1073c5.27,0,8.52-2.39,8.52-7.65V1004.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 328.95,
    y: 274.33,
    width: 1464.42,
    height: 759.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 340.29,
    y: 274.33,
    width: 1439.48,
    height: 739.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1816,231.26H308.86c-10.3,0-20.71,8.34-20.71,18.63v22.36c0,5,3,9.74,6.56,13.24a19.83,19.83,0,0,0,13.81,5.4l1506-14.21c10.23-.09,17.37-8.41,17.37-18.63v-8.16C1831.91,239.6,1826.27,231.26,1816,231.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1816,1004.27H308.86c-10.3,0-20.71,9.55-20.71,19.84v22.36c0,5,3,9.74,6.56,13.24a19.88,19.88,0,0,0,13.81,5.4l1506-14.21c10.23-.1,17.37-8.41,17.37-18.64v-8.15C1831.91,1013.82,1826.27,1004.27,1816,1004.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1724.84,317.83,384,310c-5.63,0-12.07,2.18-16.05,6.14s-7.27,9.35-7.27,15V970.24c0,11.66,11.57,20.43,23.23,20.43H1724.79c11.66,0,21-8.77,21-20.43V338.94A21.06,21.06,0,0,0,1724.84,317.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1393,
    y: 479.27,
    width: 15.03,
    height: 117.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1418.11,
    y: 519.69,
    width: 15.03,
    height: 77.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1443.23,
    y: 419.8,
    width: 15.03,
    height: 177.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1468.34,
    y: 554.34,
    width: 15.03,
    height: 42.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1493.45,
    y: 443.47,
    width: 15.03,
    height: 153.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1518.57,
    y: 470.04,
    width: 15.03,
    height: 126.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1543.68,
    y: 498.91,
    width: 15.03,
    height: 97.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1568.79,
    y: 384,
    width: 15.03,
    height: 212.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1593.91,
    y: 406.52,
    width: 15.03,
    height: 190.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1619.02,
    y: 440.59,
    width: 15.03,
    height: 156.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1644.13,
    y: 558.29,
    width: 15.03,
    height: 38.59
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 492.17,
    y: 387.67,
    width: 183.62,
    height: 45.34,
    rx: 11.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 492.17,
    y: 439.81,
    width: 183.62,
    height: 45.34,
    rx: 11.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 492.17,
    y: 491.95,
    width: 183.62,
    height: 45.34,
    rx: 11.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1009.92,448.77l279.23-5.69a5.07,5.07,0,0,1,5.18,5.12l0,4.5a5.08,5.08,0,0,1-5,5l-279.18,1.19a5.08,5.08,0,0,1-5.1-5.13h0A5.07,5.07,0,0,1,1009.92,448.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1004.72,477.2v1.91a5.07,5.07,0,0,0,5,5.13l279.15,2.66a5.07,5.07,0,0,0,5.13-5V480a5.07,5.07,0,0,0-5-5.13l-279.15-2.66A5.08,5.08,0,0,0,1004.72,477.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1089.21,503v.84a5.09,5.09,0,0,0,5,5.13l194.42,1.85a5.07,5.07,0,0,0,5.13-5l0-3.95a5.08,5.08,0,0,0-5.11-5.12L1094.26,498A5.08,5.08,0,0,0,1089.21,503Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1231.3,668.71a3.43,3.43,0,0,1-2.18-.78l-91.8-76.43-92.16,65.82a3.4,3.4,0,0,1-4.61-.62L915.1,502.48C898.19,517,805.73,596.09,793.25,606.74a3.4,3.4,0,1,1-4.42-5.17c13.74-11.73,124.5-106.52,124.5-106.52a3.41,3.41,0,0,1,4.85.44l125.63,154.44,91.69-65.49a3.42,3.42,0,0,1,4.16.16l91.61,76.27,49.78-42.47a3.4,3.4,0,1,1,4.42,5.17l-52,44.33A3.41,3.41,0,0,1,1231.3,668.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M914.36,758.43h0a2.27,2.27,0,0,1-2.24-2.3v-1.24a2.27,2.27,0,0,1,2.27-2.24h0a2.26,2.26,0,0,1,2.24,2.29v1.25A2.28,2.28,0,0,1,914.36,758.43Zm.21-17.11h0a2.28,2.28,0,0,1-2.24-2.3l.08-6.8a2.28,2.28,0,0,1,2.27-2.24h0a2.28,2.28,0,0,1,2.24,2.3l-.09,6.8A2.26,2.26,0,0,1,914.57,741.32Zm.27-22.67h0a2.27,2.27,0,0,1-2.24-2.29l.08-6.8a2.27,2.27,0,0,1,2.27-2.24h0a2.27,2.27,0,0,1,2.24,2.29l-.08,6.8A2.28,2.28,0,0,1,914.84,718.65Zm.27-22.67h0a2.27,2.27,0,0,1-2.24-2.29l.09-6.8a2.26,2.26,0,0,1,2.26-2.24h0a2.27,2.27,0,0,1,2.24,2.29l-.08,6.8A2.28,2.28,0,0,1,915.11,696Zm.27-22.67h0a2.27,2.27,0,0,1-2.24-2.29l.09-6.8a2.26,2.26,0,0,1,2.26-2.24h0a2.27,2.27,0,0,1,2.24,2.29l-.08,6.81A2.27,2.27,0,0,1,915.38,673.31Zm.27-22.66h0a2.27,2.27,0,0,1-2.24-2.3l.08-6.8a2.25,2.25,0,0,1,2.29-2.24,2.27,2.27,0,0,1,2.24,2.3l-.08,6.8A2.27,2.27,0,0,1,915.65,650.65Zm.27-22.67h0a2.27,2.27,0,0,1-2.24-2.29l.08-6.81a2.27,2.27,0,0,1,2.27-2.23h0a2.25,2.25,0,0,1,2.24,2.29l-.08,6.8A2.27,2.27,0,0,1,915.92,628Zm.28-22.67h0a2.26,2.26,0,0,1-2.24-2.29l.08-6.8a2.36,2.36,0,0,1,2.3-2.24,2.25,2.25,0,0,1,2.23,2.29l-.08,6.8A2.25,2.25,0,0,1,916.2,605.31Zm.27-22.66h0a2.28,2.28,0,0,1-2.24-2.3l.08-6.8a2.21,2.21,0,0,1,2.3-2.24,2.27,2.27,0,0,1,2.24,2.29l-.08,6.81A2.28,2.28,0,0,1,916.47,582.65Zm.27-22.67h0a2.28,2.28,0,0,1-2.24-2.3l.08-6.8a2.28,2.28,0,0,1,2.27-2.24h0a2.28,2.28,0,0,1,2.24,2.3l-.08,6.8A2.28,2.28,0,0,1,916.74,560Zm.27-22.67h0a2.27,2.27,0,0,1-2.24-2.29l.09-6.8a2.25,2.25,0,0,1,2.26-2.24h0a2.27,2.27,0,0,1,2.24,2.29l-.08,6.8A2.28,2.28,0,0,1,917,537.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1042.19,740.13h0a2.28,2.28,0,0,1-2.24-2.3l.08-6.8a2.25,2.25,0,0,1,2.3-2.24,2.28,2.28,0,0,1,2.24,2.3l-.08,6.8A2.28,2.28,0,0,1,1042.19,740.13Zm.27-22.67h0a2.27,2.27,0,0,1-2.24-2.29l.09-6.81a2.29,2.29,0,0,1,2.29-2.23,2.27,2.27,0,0,1,2.24,2.29l-.08,6.8A2.28,2.28,0,0,1,1042.46,717.46Zm.27-22.67h0a2.25,2.25,0,0,1-2.24-2.29l.08-6.8a2.24,2.24,0,0,1,2.29-2.24,2.26,2.26,0,0,1,2.24,2.29l-.08,6.8A2.27,2.27,0,0,1,1042.73,694.79Zm.28-22.67h0a2.25,2.25,0,0,1-2.24-2.29l.08-6.8a2.27,2.27,0,0,1,2.27-2.24h0a2.26,2.26,0,0,1,2.24,2.29l-.08,6.81A2.26,2.26,0,0,1,1043,672.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1138.8,747.27a2.26,2.26,0,0,1-2.26-2.22l-.13-6.8a2.27,2.27,0,0,1,2.22-2.31,2.31,2.31,0,0,1,2.31,2.22l.13,6.8a2.26,2.26,0,0,1-2.22,2.31Zm-.43-22.66a2.26,2.26,0,0,1-2.26-2.23l-.13-6.8a2.27,2.27,0,1,1,4.53-.08l.13,6.8a2.27,2.27,0,0,1-2.22,2.31Zm-.43-22.67a2.27,2.27,0,0,1-2.27-2.22l-.12-6.8a2.26,2.26,0,0,1,2.22-2.31,2.31,2.31,0,0,1,2.31,2.22l.13,6.8a2.27,2.27,0,0,1-2.23,2.31Zm-.43-22.66a2.28,2.28,0,0,1-2.27-2.23l-.13-6.8a2.28,2.28,0,0,1,2.23-2.31,2.31,2.31,0,0,1,2.31,2.23l.13,6.8a2.27,2.27,0,0,1-2.23,2.31Zm-.43-22.67a2.27,2.27,0,0,1-2.27-2.22l-.13-6.8a2.27,2.27,0,0,1,2.23-2.31,2.29,2.29,0,0,1,2.31,2.22l.13,6.8a2.28,2.28,0,0,1-2.23,2.31Zm-.43-22.66a2.27,2.27,0,0,1-2.27-2.23l-.13-6.8a2.27,2.27,0,1,1,4.53-.08l.13,6.8a2.27,2.27,0,0,1-2.22,2.31Zm-.44-22.67a2.26,2.26,0,0,1-2.26-2.22l-.13-6.8a2.27,2.27,0,1,1,4.53-.09l.13,6.8a2.26,2.26,0,0,1-2.22,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1231.55,748.44h0a2.27,2.27,0,0,1-2.24-2.3l.08-6.8a2.19,2.19,0,0,1,2.29-2.24,2.27,2.27,0,0,1,2.24,2.3l-.08,6.8A2.26,2.26,0,0,1,1231.55,748.44Zm.27-22.67h0a2.27,2.27,0,0,1-2.24-2.29l.08-6.8a2.32,2.32,0,0,1,2.3-2.24,2.27,2.27,0,0,1,2.24,2.29l-.09,6.8A2.26,2.26,0,0,1,1231.82,725.77Zm.27-22.67h0a2.27,2.27,0,0,1-2.24-2.29l.08-6.8a2.28,2.28,0,0,1,2.27-2.24h0a2.27,2.27,0,0,1,2.24,2.29l-.08,6.8A2.27,2.27,0,0,1,1232.09,703.1Zm.27-22.66h0a2.28,2.28,0,0,1-2.24-2.3l.08-6.8a2.28,2.28,0,0,1,2.27-2.24h0a2.28,2.28,0,0,1,2.24,2.3l-.08,6.8A2.28,2.28,0,0,1,1232.36,680.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M778.15,772.4h-.08a3.4,3.4,0,0,1-3.32-3.48l7.14-302.6a3.4,3.4,0,1,1,6.79.16l-7.13,302.6A3.4,3.4,0,0,1,778.15,772.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "773.44 479.67 785.24 468.41 796.49 480.21 796.72 470.43 785.47 458.63 773.67 469.88 773.44 479.67"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "778.46 457.95 778.2 478.35 773.27 478.35 773.27 457.95 778.46 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "778.52 457.95 778.27 478.35 778.2 478.35 778.46 457.95 778.52 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "778.59 457.95 778.34 478.35 778.27 478.35 778.52 457.95 778.59 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "778.66 457.95 778.4 478.35 778.34 478.35 778.59 457.95 778.66 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "778.73 457.95 778.47 478.35 778.4 478.35 778.66 457.95 778.73 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "778.8 457.95 778.54 478.35 778.47 478.35 778.73 457.95 778.8 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "778.87 457.95 778.61 478.35 778.54 478.35 778.8 457.95 778.87 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "778.94 457.95 778.68 478.35 778.61 478.35 778.87 457.95 778.94 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "779 457.95 778.75 478.35 778.68 478.35 778.94 457.95 779 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "779.07 457.95 778.82 478.35 778.75 478.35 779 457.95 779.07 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "779.14 457.95 778.88 478.35 778.82 478.35 779.07 457.95 779.14 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "779.21 457.95 778.95 478.35 778.88 478.35 779.14 457.95 779.21 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "779.28 457.95 779.02 478.35 778.95 478.35 779.21 457.95 779.28 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "779.35 457.95 779.09 478.35 779.02 478.35 779.28 457.95 779.35 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "779.41 457.95 779.16 478.35 779.09 478.35 779.35 457.95 779.41 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "779.48 457.95 779.23 478.35 779.16 478.35 779.41 457.95 779.48 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "779.55 457.95 779.29 478.35 779.23 478.35 779.48 457.95 779.55 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "779.62 457.95 779.36 478.35 779.29 478.35 779.55 457.95 779.62 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "779.69 457.95 779.43 478.35 779.36 478.35 779.62 457.95 779.69 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "779.76 457.95 779.5 478.35 779.43 478.35 779.69 457.95 779.76 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "779.83 457.95 779.57 478.35 779.5 478.35 779.76 457.95 779.83 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "779.89 457.95 779.64 478.35 779.57 478.35 779.83 457.95 779.89 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "779.96 457.95 779.71 478.35 779.64 478.35 779.89 457.95 779.96 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780.03 457.95 779.77 478.35 779.71 478.35 779.96 457.95 780.03 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780.1 457.95 779.84 478.35 779.77 478.35 780.03 457.95 780.1 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780.17 457.95 779.91 478.35 779.84 478.35 780.1 457.95 780.17 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780.24 457.95 779.98 478.35 779.91 478.35 780.17 457.95 780.24 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780.31 457.95 780.05 478.35 779.98 478.35 780.24 457.95 780.31 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780.37 457.95 780.12 478.35 780.05 478.35 780.31 457.95 780.37 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780.44 457.95 780.18 478.35 780.12 478.35 780.37 457.95 780.44 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780.51 457.95 780.25 478.35 780.18 478.35 780.44 457.95 780.51 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780.58 457.95 780.32 478.35 780.25 478.35 780.51 457.95 780.58 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780.65 457.95 780.39 478.35 780.32 478.35 780.58 457.95 780.65 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780.72 457.95 780.46 478.35 780.39 478.35 780.65 457.95 780.72 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780.78 457.95 780.53 478.35 780.46 478.35 780.72 457.95 780.78 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780.85 457.95 780.6 478.35 780.53 478.35 780.78 457.95 780.85 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780.92 457.95 780.66 478.35 780.6 478.35 780.85 457.95 780.92 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "780.99 457.95 780.73 478.35 780.66 478.35 780.92 457.95 780.99 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "781.06 457.95 780.8 478.35 780.73 478.35 780.99 457.95 781.06 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "781.13 457.95 780.87 478.35 780.8 478.35 781.06 457.95 781.13 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "781.2 457.95 780.94 478.35 780.87 478.35 781.13 457.95 781.2 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "781.26 457.95 781.01 478.35 780.94 478.35 781.2 457.95 781.26 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "781.33 457.95 781.08 478.35 781.01 478.35 781.26 457.95 781.33 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "781.4 457.95 781.14 478.35 781.08 478.35 781.33 457.95 781.4 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "781.47 457.95 781.21 478.35 781.14 478.35 781.4 457.95 781.47 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "781.54 457.95 781.28 478.35 781.21 478.35 781.47 457.95 781.54 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "781.61 457.95 781.35 478.35 781.28 478.35 781.54 457.95 781.61 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "781.68 457.95 781.42 478.35 781.35 478.35 781.61 457.95 781.68 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "781.74 457.95 781.49 478.35 781.42 478.35 781.68 457.95 781.74 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "781.81 457.95 781.55 478.35 781.49 478.35 781.74 457.95 781.81 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "781.88 457.95 781.62 478.35 781.55 478.35 781.81 457.95 781.88 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "781.95 457.95 781.69 478.35 781.62 478.35 781.88 457.95 781.95 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.02 457.95 781.76 478.35 781.69 478.35 781.95 457.95 782.02 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.09 457.95 781.83 478.35 781.76 478.35 782.02 457.95 782.09 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.15 457.95 781.9 478.35 781.83 478.35 782.09 457.95 782.15 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.22 457.95 781.97 478.35 781.9 478.35 782.15 457.95 782.22 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.29 457.95 782.03 478.35 781.97 478.35 782.22 457.95 782.29 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.36 457.95 782.1 478.35 782.03 478.35 782.29 457.95 782.36 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.43 457.95 782.17 478.35 782.1 478.35 782.36 457.95 782.43 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.5 457.95 782.24 478.35 782.17 478.35 782.43 457.95 782.5 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.57 457.95 782.31 478.35 782.24 478.35 782.5 457.95 782.57 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.63 457.95 782.38 478.35 782.31 478.35 782.57 457.95 782.63 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.7 457.95 782.45 478.35 782.38 478.35 782.63 457.95 782.7 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.77 457.95 782.51 478.35 782.45 478.35 782.7 457.95 782.77 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.84 457.95 782.58 478.35 782.51 478.35 782.77 457.95 782.84 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.91 457.95 782.65 478.35 782.58 478.35 782.84 457.95 782.91 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "782.98 457.95 782.72 478.35 782.65 478.35 782.91 457.95 782.98 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "783.05 457.95 782.79 478.35 782.72 478.35 782.98 457.95 783.05 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "783.12 457.95 782.86 478.35 782.79 478.35 783.05 457.95 783.12 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "783.18 457.95 782.92 478.35 782.86 478.35 783.12 457.95 783.18 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "783.25 457.95 782.99 478.35 782.92 478.35 783.18 457.95 783.25 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "783.32 457.95 783.06 478.35 782.99 478.35 783.25 457.95 783.32 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "783.39 457.95 783.13 478.35 783.06 478.35 783.32 457.95 783.39 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "783.46 457.95 783.2 478.35 783.13 478.35 783.39 457.95 783.46 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "783.53 457.95 783.27 478.35 783.2 478.35 783.46 457.95 783.53 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "783.59 457.95 783.34 478.35 783.27 478.35 783.53 457.95 783.59 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "783.66 457.95 783.4 478.35 783.34 478.35 783.59 457.95 783.66 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "783.73 457.95 783.47 478.35 783.4 478.35 783.66 457.95 783.73 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "783.8 457.95 783.54 478.35 783.47 478.35 783.73 457.95 783.8 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "783.87 457.95 783.61 478.35 783.54 478.35 783.8 457.95 783.87 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "783.94 457.95 783.68 478.35 783.61 478.35 783.87 457.95 783.94 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "784 457.95 783.75 478.35 783.68 478.35 783.94 457.95 784 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "784.07 457.95 783.82 478.35 783.75 478.35 784 457.95 784.07 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "784.14 457.95 783.88 478.35 783.82 478.35 784.07 457.95 784.14 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "784.21 457.95 783.95 478.35 783.88 478.35 784.14 457.95 784.21 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "784.28 457.95 784.02 478.35 783.95 478.35 784.21 457.95 784.28 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "784.35 457.95 784.09 478.35 784.02 478.35 784.28 457.95 784.35 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "784.42 457.95 784.16 478.35 784.09 478.35 784.35 457.95 784.42 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "784.49 457.95 784.23 478.35 784.16 478.35 784.42 457.95 784.49 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "784.55 457.95 784.29 478.35 784.23 478.35 784.49 457.95 784.55 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "784.62 457.95 784.36 478.35 784.29 478.35 784.55 457.95 784.62 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "784.69 457.95 784.43 478.35 784.36 478.35 784.62 457.95 784.69 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "784.76 457.95 784.5 478.35 784.43 478.35 784.69 457.95 784.76 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "784.83 457.95 784.57 478.35 784.5 478.35 784.76 457.95 784.83 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "784.9 457.95 784.64 478.35 784.57 478.35 784.83 457.95 784.9 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "784.96 457.95 784.71 478.35 784.64 478.35 784.9 457.95 784.96 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "785.03 457.95 784.77 478.35 784.71 478.35 784.96 457.95 785.03 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "785.1 457.95 784.84 478.35 784.77 478.35 785.03 457.95 785.1 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "785.17 457.95 784.91 478.35 784.84 478.35 785.1 457.95 785.17 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "785.24 457.95 784.98 478.35 784.91 478.35 785.17 457.95 785.24 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "785.31 457.95 785.05 478.35 784.98 478.35 785.24 457.95 785.31 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "785.38 457.95 785.12 478.35 785.05 478.35 785.31 457.95 785.38 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "785.44 457.95 785.19 478.35 785.12 478.35 785.38 457.95 785.44 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "785.51 457.95 785.25 478.35 785.19 478.35 785.44 457.95 785.51 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "785.58 457.95 785.32 478.35 785.25 478.35 785.51 457.95 785.58 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "785.65 457.95 785.39 478.35 785.32 478.35 785.58 457.95 785.65 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "785.72 457.95 785.46 478.35 785.39 478.35 785.65 457.95 785.72 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "785.79 457.95 785.53 478.35 785.46 478.35 785.72 457.95 785.79 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "785.86 457.95 785.6 478.35 785.53 478.35 785.79 457.95 785.86 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "785.92 457.95 785.67 478.35 785.6 478.35 785.86 457.95 785.92 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "785.99 457.95 785.73 478.35 785.67 478.35 785.92 457.95 785.99 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "786.06 457.95 785.8 478.35 785.73 478.35 785.99 457.95 786.06 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "786.13 457.95 785.87 478.35 785.8 478.35 786.06 457.95 786.13 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "786.2 457.95 785.94 478.35 785.87 478.35 786.13 457.95 786.2 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "786.27 457.95 786.01 478.35 785.94 478.35 786.2 457.95 786.27 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "786.33 457.95 786.08 478.35 786.01 478.35 786.27 457.95 786.33 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "786.4 457.95 786.14 478.35 786.08 478.35 786.33 457.95 786.4 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "786.47 457.95 786.21 478.35 786.14 478.35 786.4 457.95 786.47 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "786.54 457.95 786.28 478.35 786.21 478.35 786.47 457.95 786.54 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "786.61 457.95 786.35 478.35 786.28 478.35 786.54 457.95 786.61 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "786.68 457.95 786.42 478.35 786.35 478.35 786.61 457.95 786.68 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "786.75 457.95 786.49 478.35 786.42 478.35 786.68 457.95 786.75 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "786.81 457.95 786.56 478.35 786.49 478.35 786.75 457.95 786.81 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "786.88 457.95 786.63 478.35 786.56 478.35 786.81 457.95 786.88 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "786.95 457.95 786.69 478.35 786.63 478.35 786.88 457.95 786.95 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "787.02 457.95 786.76 478.35 786.69 478.35 786.95 457.95 787.02 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "787.09 457.95 786.83 478.35 786.76 478.35 787.02 457.95 787.09 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "787.16 457.95 786.9 478.35 786.83 478.35 787.09 457.95 787.16 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "787.23 457.95 786.97 478.35 786.9 478.35 787.16 457.95 787.23 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "787.29 457.95 787.04 478.35 786.97 478.35 787.23 457.95 787.29 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "787.36 457.95 787.1 478.35 787.04 478.35 787.29 457.95 787.36 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "787.43 457.95 787.17 478.35 787.1 478.35 787.36 457.95 787.43 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "787.5 457.95 787.24 478.35 787.17 478.35 787.43 457.95 787.5 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "787.57 457.95 787.31 478.35 787.24 478.35 787.5 457.95 787.57 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "787.64 457.95 787.38 478.35 787.31 478.35 787.57 457.95 787.64 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "787.7 457.95 787.45 478.35 787.38 478.35 787.64 457.95 787.7 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "787.77 457.95 787.51 478.35 787.45 478.35 787.7 457.95 787.77 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "787.84 457.95 787.58 478.35 787.51 478.35 787.77 457.95 787.84 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "787.91 457.95 787.65 478.35 787.58 478.35 787.84 457.95 787.91 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "787.98 457.95 787.72 478.35 787.65 478.35 787.91 457.95 787.98 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "788.05 457.95 787.79 478.35 787.72 478.35 787.98 457.95 788.05 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "788.12 457.95 787.86 478.35 787.79 478.35 788.05 457.95 788.12 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "788.18 457.95 787.93 478.35 787.86 478.35 788.12 457.95 788.18 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "788.25 457.95 788 478.35 787.93 478.35 788.18 457.95 788.25 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "788.32 457.95 788.06 478.35 788 478.35 788.25 457.95 788.32 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "788.39 457.95 788.13 478.35 788.06 478.35 788.32 457.95 788.39 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "788.46 457.95 788.2 478.35 788.13 478.35 788.39 457.95 788.46 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "788.53 457.95 788.27 478.35 788.2 478.35 788.46 457.95 788.53 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "788.6 457.95 788.34 478.35 788.27 478.35 788.53 457.95 788.6 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "788.66 457.95 788.41 478.35 788.34 478.35 788.6 457.95 788.66 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "788.73 457.95 788.47 478.35 788.41 478.35 788.66 457.95 788.73 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "788.8 457.95 788.54 478.35 788.47 478.35 788.73 457.95 788.8 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "788.87 457.95 788.61 478.35 788.54 478.35 788.8 457.95 788.87 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "788.61 478.35 788.87 457.95 795.93 457.95 795.93 478.35 788.61 478.35"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1294.3,764.11h0l-535.7-6.42a3.4,3.4,0,1,1,.09-6.8l535.69,6.42a3.4,3.4,0,0,1,0,6.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1280.62 772.08 1292.29 760.69 1280.9 749.02 1290.68 749.14 1302.08 760.8 1290.41 772.19 1280.62 772.08"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1283.89 748.11 1283.62 770.78 1281.05 770.78 1281.05 748.11 1283.89 748.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1287.51 748.11 1287.24 770.78 1283.62 770.78 1283.89 748.11 1287.51 748.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1291.13 748.11 1290.86 770.78 1287.24 770.78 1287.51 748.11 1291.13 748.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1294.76 748.11 1294.48 770.78 1290.86 770.78 1291.13 748.11 1294.76 748.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1298.38 748.11 1298.1 770.78 1294.48 770.78 1294.76 748.11 1298.38 748.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1302 748.11 1301.72 770.78 1298.1 770.78 1298.38 748.11 1302 748.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1301.72 770.78 1302 748.11 1301.45 748.11 1301.45 770.78 1301.72 770.78"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 1435.34,
    cy: 709.36,
    r: 35.01,
    transform: "translate(555.93 2047.28) rotate(-82.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 1522.35,
    cy: 709.36,
    r: 35.01,
    transform: "translate(-129.26 404.55) rotate(-14.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 1609.35,
    cy: 710.5,
    r: 35.01,
    transform: "translate(-119.13 383.1) rotate(-13.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1456.15,702A22.49,22.49,0,1,1,1435.34,688c.39,0,.76,0,1.14,0v-5.7c-.38,0-.75,0-1.14,0a28.19,28.19,0,1,0,26,17.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1534,729.53A22.49,22.49,0,1,1,1522,688c.38,0,.75,0,1.13,0v-5.7c-.38,0-.75,0-1.13,0a28.18,28.18,0,1,0,14.8,52.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1628.11,723.15A22.49,22.49,0,1,1,1609.52,688c.38,0,.76,0,1.13,0v-5.7c-.37,0-.75,0-1.13,0a28.18,28.18,0,1,0,23.21,44.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1463.87,759.19h-57a6.49,6.49,0,0,0,0,13h57a6.49,6.49,0,0,0,0-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1550.87,759.19h-57a6.49,6.49,0,0,0,0,13h57a6.49,6.49,0,0,0,0-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1580.83,772.16h57a6.49,6.49,0,1,0,0-13h-57a6.49,6.49,0,1,0,0,13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1400.34,
    y: 779.36,
    width: 70.01,
    height: 51.15,
    rx: 6.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1487.34,
    y: 779.36,
    width: 70.01,
    height: 51.15,
    rx: 6.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1574.34,
    y: 779.36,
    width: 70.01,
    height: 51.15,
    rx: 6.48
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.32,972.35l-3.21-6.07a1.54,1.54,0,1,1,2.72-1.44h0l0,.06,3.14,6,0,.06a1.53,1.53,0,0,1-2.71,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M217.77,951.54,215.63,945a1.56,1.56,0,0,1,1-2,1.54,1.54,0,0,1,2,1h0l0,.08,2.08,6.38,0,.09a1.55,1.55,0,0,1-2.95,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M212.25,929.26q-.47-3.43-.67-6.88a1.57,1.57,0,0,1,3.13-.19h0c.13,2.22.35,4.44.64,6.65a1.56,1.56,0,1,1-3.1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M212,906.26c.27-2.3.64-4.58,1.09-6.84a1.58,1.58,0,1,1,3.1.62h0q-.66,3.27-1.06,6.59a1.58,1.58,0,0,1-3.13-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M217.7,884c.85-2.14,1.79-4.25,2.79-6.32a1.59,1.59,0,0,1,2.87,1.39h0c-1,2-1.88,4-2.7,6.11a1.59,1.59,0,0,1-3-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.67,863.75l4.12-5.53a1.61,1.61,0,1,1,2.58,1.93h0l-.06.07-4,5.37-.06.08a1.6,1.6,0,1,1-2.57-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M243.56,846.31l5-4.69a1.63,1.63,0,0,1,2.22,2.38h0l-.06,0-4.92,4.58-.06,0a1.62,1.62,0,1,1-2.21-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261.1,831.6l5.62-3.92a1.64,1.64,0,1,1,1.88,2.68h0l-.05,0L263,834.24l-.05,0a1.63,1.63,0,1,1-1.86-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M280.36,819.32l6-3.25A1.65,1.65,0,1,1,288,819h0l0,0L282,822.2l0,0a1.64,1.64,0,0,1-2.23-.66A1.66,1.66,0,0,1,280.36,819.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M300.79,809.16l6.3-2.68a1.67,1.67,0,0,1,1.3,3.07h0l-6.22,2.64,0,0a1.66,1.66,0,1,1-1.3-3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M322,800.83l6.49-2.17a1.68,1.68,0,0,1,1.06,3.18h0l0,0L323.11,804h0a1.68,1.68,0,0,1-1.07-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M343.78,794.12l6.62-1.72a1.69,1.69,0,0,1,.85,3.28h0l-6.55,1.7h0a1.69,1.69,0,0,1-.85-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M365.94,788.88l6.71-1.31a1.71,1.71,0,1,1,.65,3.35h0l-6.65,1.29h0a1.7,1.7,0,0,1-.65-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M388.37,785l6.76-.93a1.72,1.72,0,1,1,.47,3.41h0l-6.71.91h0a1.72,1.72,0,0,1-.46-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M411,782.31l6.8-.57a1.74,1.74,0,1,1,.29,3.46h0l-6.75.55h0a1.73,1.73,0,0,1-.28-3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M433.68,780.83l6.82-.21a1.74,1.74,0,0,1,1.81,1.69,1.76,1.76,0,0,1-1.7,1.81h0l-6.77.2h0a1.75,1.75,0,0,1-.11-3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M456.43,780.5l6.82.12a1.77,1.77,0,1,1-.06,3.53h0l-6.77-.13h0a1.76,1.76,0,0,1,.06-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M479.17,781.28l6.81.45a1.79,1.79,0,0,1,1.66,1.9,1.77,1.77,0,0,1-1.89,1.65h0l-6.76-.45h0a1.78,1.78,0,0,1,.24-3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M501.83,783.14l6.78.7a1.79,1.79,0,1,1-.37,3.56h0l-6.75-.71h0a1.78,1.78,0,1,1,.37-3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M524.41,785.69l6.75.88a1.8,1.8,0,1,1-.46,3.58h0l-6.73-.89h0a1.8,1.8,0,1,1,.47-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M546.9,788.83l6.74,1a1.81,1.81,0,0,1-.56,3.58h0l-6.7-1.05h0a1.81,1.81,0,1,1,.56-3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M569.31,792.52l6.71,1.22a1.82,1.82,0,0,1-.65,3.59h0l-6.68-1.22h0a1.82,1.82,0,0,1,.65-3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M591.63,796.75l6.67,1.37a1.84,1.84,0,0,1-.74,3.61h0l-6.65-1.37h0a1.84,1.84,0,1,1,.74-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M613.84,801.5l6.64,1.52a1.85,1.85,0,1,1-.83,3.6h0L613,805.1h0a1.85,1.85,0,0,1,.83-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M635.93,806.73l6.61,1.66a1.86,1.86,0,0,1-.9,3.61h0L635,810.33h0a1.86,1.86,0,1,1,.9-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M657.92,812.42l6.57,1.79a1.87,1.87,0,0,1-1,3.61h0L656.94,816a1.87,1.87,0,1,1,1-3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M679.78,818.54l6.54,1.92a1.88,1.88,0,0,1-1.06,3.61h0l-6.51-1.92a1.88,1.88,0,1,1,1-3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M701.52,825.07l6.5,2a1.9,1.9,0,1,1-1.13,3.62h0l-6.48-2a1.89,1.89,0,1,1,1.12-3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M723.15,832l6.46,2.14a1.91,1.91,0,1,1-1.2,3.62h0L722,835.59a1.9,1.9,0,1,1,1.19-3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M744.66,839.24l6.42,2.24a1.92,1.92,0,1,1-1.26,3.62h0l-6.41-2.24a1.92,1.92,0,1,1,1.26-3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M766.05,846.83l6.39,2.33a1.93,1.93,0,0,1-1.32,3.63h0l-6.38-2.33a1.93,1.93,0,1,1,1.32-3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M787.33,854.71l6.36,2.42a1.94,1.94,0,0,1-1.38,3.63h0L786,858.34a1.94,1.94,0,1,1,1.38-3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M808.5,862.87l6.33,2.5A2,2,0,0,1,813.4,869h0l-6.31-2.5a1.95,1.95,0,1,1,1.42-3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M829.58,871.28l6.3,2.57a2,2,0,0,1-1.48,3.64h0l-6.29-2.57a2,2,0,1,1,1.48-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M850.56,879.92l6.28,2.63a2,2,0,1,1-1.53,3.64h0L849,883.56a2,2,0,0,1,1.52-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M871.46,888.75l6.25,2.68a2,2,0,1,1-1.57,3.65h0l-6.25-2.68a2,2,0,0,1,1.57-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M892.28,897.75l6.23,2.73a2,2,0,0,1,1,2.64,2,2,0,0,1-2.63,1h0l-6.22-2.73a2,2,0,0,1,1.6-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M913,906.9l6.22,2.77a2,2,0,0,1-1.64,3.68h0l-6.2-2.78A2,2,0,1,1,913,906.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M933.73,916.18l6.2,2.8a2,2,0,1,1-1.67,3.69h0l-6.19-2.81a2,2,0,0,1,1.67-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M954.38,925.56l6.18,2.83a2,2,0,1,1-1.69,3.7h0l-6.18-2.84a2,2,0,1,1,1.69-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M975,935l6.17,2.85a2,2,0,1,1-1.71,3.71h0l-6.17-2.85A2,2,0,0,1,975,935Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M995.57,944.51l6.17,2.85a2.06,2.06,0,0,1-1.72,3.74h0l-6.17-2.86a2.06,2.06,0,0,1,1.73-3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1016.14,954l6.18,2.85a2.07,2.07,0,1,1-1.74,3.76h0l-6.17-2.86a2.06,2.06,0,1,1,1.73-3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1036.72,963.52l6.18,2.84a2.08,2.08,0,1,1-1.74,3.78h0l-6.18-2.85a2.08,2.08,0,0,1,1.74-3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1057.32,973l6.18,2.83a2.09,2.09,0,1,1-1.74,3.81h0l-6.18-2.84a2.09,2.09,0,1,1,1.74-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1077.94,982.37l6.19,2.8a2.1,2.1,0,1,1-1.73,3.83h0l-6.2-2.81a2.1,2.1,0,0,1,1.74-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1098.6,991.67l6.2,2.77a2.12,2.12,0,0,1-1.71,3.87h0l-6.21-2.78a2.11,2.11,0,1,1,1.73-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1119.31,1000.86l6.22,2.73a2.13,2.13,0,1,1-1.7,3.9h0l-6.23-2.74a2.12,2.12,0,1,1,1.72-3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1140.07,1009.9l6.25,2.68a2.14,2.14,0,0,1-1.68,3.94h0l-6.25-2.7a2.13,2.13,0,1,1,1.69-3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1160.91,1018.78l6.26,2.63a2.15,2.15,0,0,1-1.65,4h0l-6.27-2.64a2.15,2.15,0,1,1,1.67-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1181.82,1027.47l6.29,2.56a2.16,2.16,0,1,1-1.62,4h0l-6.3-2.58a2.16,2.16,0,1,1,1.63-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1202.82,1035.94l6.32,2.49a2.17,2.17,0,1,1-1.58,4h0l-6.33-2.51a2.17,2.17,0,1,1,1.6-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1223.92,1044.16l6.35,2.42a2.19,2.19,0,0,1-1.54,4.09h0l-6.36-2.43a2.18,2.18,0,1,1,1.56-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1245.11,1052.11l6.38,2.33a2.2,2.2,0,0,1-1.49,4.14h0l-6.39-2.34a2.19,2.19,0,1,1,1.51-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1266.41,1059.77l6.42,2.23a2.21,2.21,0,0,1-1.44,4.18h0l-6.43-2.25a2.2,2.2,0,1,1,1.46-4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1287.83,1067.1l6.44,2.13a2.22,2.22,0,0,1-1.37,4.23h0l-6.47-2.14a2.22,2.22,0,0,1,1.41-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1309.35,1074.08l6.48,2h0a2.23,2.23,0,1,1-1.33,4.26h0l-6.5-2a2.23,2.23,0,1,1,1.33-4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1331,1080.69l6.52,1.9h0a2.24,2.24,0,1,1-1.26,4.3h0l-6.54-1.92a2.24,2.24,0,0,1,1.26-4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1352.75,1086.89l6.55,1.78h0a2.25,2.25,0,0,1-1.19,4.35h0l-6.57-1.79a2.25,2.25,0,1,1,1.18-4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1374.63,1092.67l6.58,1.64h0a2.27,2.27,0,1,1-1.1,4.4h0l-6.61-1.66a2.26,2.26,0,0,1,1.1-4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1396.61,1098l6.62,1.5h0a2.28,2.28,0,1,1-1,4.44h0l-6.64-1.51a2.28,2.28,0,0,1,1-4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1418.7,1102.83l6.65,1.35h0a2.29,2.29,0,1,1-.92,4.48h0l-6.68-1.37a2.28,2.28,0,1,1,.92-4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1440.9,1107.17l6.68,1.2h0a2.3,2.3,0,1,1-.81,4.52h0l-6.71-1.21a2.3,2.3,0,1,1,.82-4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1463.19,1111l6.7,1h0a2.31,2.31,0,0,1-.7,4.57h0l-6.74-1a2.31,2.31,0,1,1,.71-4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1485.56,1114.19l6.73.84h0a2.32,2.32,0,1,1-.58,4.61h0l-6.77-.85a2.32,2.32,0,1,1,.58-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1508,1116.76l6.75.64h0a2.33,2.33,0,1,1-.44,4.64h0l-6.79-.65a2.33,2.33,0,1,1,.45-4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1530.53,1118.69l6.77.45h0a2.35,2.35,0,1,1-.32,4.68h0l-6.8-.46a2.34,2.34,0,1,1,.32-4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1553.1,1120l6.77.26h0a2.36,2.36,0,1,1-.18,4.71h0l-6.82-.27a2.35,2.35,0,1,1,.19-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1575.69,1120.62l6.78.07h0a2.37,2.37,0,1,1,0,4.74h0l-6.82-.08a2.37,2.37,0,1,1,.05-4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1598.29,1120.61l6.78-.13h0a2.38,2.38,0,1,1,.09,4.76h0l-6.82.13a2.38,2.38,0,0,1-.09-4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1620.88,1119.94l6.77-.34h0a2.39,2.39,0,1,1,.24,4.78h0l-6.81.33a2.39,2.39,0,0,1-.23-4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1643.43,1118.58l6.76-.54h0a2.41,2.41,0,0,1,.39,4.8h0l-6.8.54a2.4,2.4,0,0,1-.38-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1665.93,1116.52l6.74-.76h0a2.42,2.42,0,0,1,.54,4.8h0l-6.79.76a2.41,2.41,0,0,1-.53-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1688.35,1113.74l6.71-1h0a2.43,2.43,0,0,1,.7,4.8h0l-6.76,1a2.42,2.42,0,1,1-.69-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1710.66,1110.22l6.67-1.21h0a2.44,2.44,0,1,1,.87,4.8h0l-6.72,1.21a2.43,2.43,0,1,1-.86-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1732.83,1105.91l6.62-1.45h0a2.45,2.45,0,0,1,1,4.79h0l-6.67,1.45a2.45,2.45,0,1,1-1-4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1754.82,1100.8l6.56-1.7h0a2.46,2.46,0,1,1,1.23,4.76h0l-6.62,1.71a2.46,2.46,0,1,1-1.22-4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1776.6,1094.84l6.48-1.95h0a2.47,2.47,0,1,1,1.43,4.73h0l-6.54,2a2.47,2.47,0,1,1-1.42-4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1798.1,1088l6.39-2.23h0a2.48,2.48,0,1,1,1.64,4.69h0l-6.46,2.24a2.48,2.48,0,1,1-1.63-4.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1819.28,1080.25l6.28-2.52h0a2.5,2.5,0,0,1,1.85,4.64h0l-6.35,2.53a2.49,2.49,0,0,1-1.85-4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1840.08,1071.52l6.15-2.81h0a2.51,2.51,0,1,1,2.09,4.56h0l-6.23,2.84a2.5,2.5,0,0,1-2.07-4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1860.41,1061.8l6-3.12,0,0a2.52,2.52,0,1,1,2.32,4.47h0l-6.07,3.15a2.52,2.52,0,0,1-2.32-4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1880.2,1051l5.82-3.44,0,0a2.53,2.53,0,1,1,2.58,4.36h0l-5.89,3.48a2.53,2.53,0,1,1-2.57-4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1899.36,1039.18l5.6-3.77,0,0a2.54,2.54,0,1,1,2.84,4.22h0l-5.69,3.82a2.54,2.54,0,0,1-2.83-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1917.77,1026.22l5.36-4.1,0,0a2.55,2.55,0,1,1,3.1,4.06h0l-5.44,4.16a2.55,2.55,0,0,1-3.1-4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1935.33,1012.15l5.08-4.44,0,0a2.57,2.57,0,0,1,3.37,3.87h0l-5.16,4.5a2.56,2.56,0,1,1-3.37-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1951.91,997l4.78-4.78,0,0a2.58,2.58,0,1,1,3.65,3.64h0l-4.86,4.85a2.57,2.57,0,1,1-3.63-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1967.44,980.68l4.44-5.08,0,0a2.59,2.59,0,1,1,3.9,3.41h0l-4.51,5.16a2.59,2.59,0,1,1-3.89-3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1981.83,963.4l4.08-5.37,0,0a2.6,2.6,0,0,1,4.14,3.15h0l-4.15,5.45a2.6,2.6,0,0,1-4.13-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1995,945.18l3.72-5.63,0,0a2.61,2.61,0,1,1,4.36,2.88h0l-3.78,5.72a2.61,2.61,0,0,1-4.36-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2007,926.12l3.34-5.86,0,0a2.63,2.63,0,0,1,4.57,2.6h0l-3.39,6a2.62,2.62,0,1,1-4.55-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2017.65,906.32l3-6.07,0,0a2.64,2.64,0,1,1,4.74,2.31h0l-3,6.15a2.63,2.63,0,1,1-4.73-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2027.05,885.88l2.57-6.24,0,0a2.64,2.64,0,1,1,4.89,2h0l-2.61,6.33a2.65,2.65,0,0,1-4.89-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2035.16,864.89l2.19-6.39v0a2.66,2.66,0,0,1,5,1.72h0l-2.22,6.47a2.65,2.65,0,1,1-5-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2042,843.44l1.81-6.5v-.05a2.67,2.67,0,1,1,5.15,1.43h0l-1.84,6.6a2.67,2.67,0,0,1-5.14-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2047.59,821.63,2049,815v0a2.68,2.68,0,0,1,5.24,1.14h0l-1.46,6.69a2.68,2.68,0,0,1-5.23-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2051.94,799.54l1.07-6.67v0a2.69,2.69,0,1,1,5.31.86h0l-1.08,6.76a2.69,2.69,0,0,1-5.32-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2055.08,777.24l.71-6.72v0a2.71,2.71,0,0,1,5.38.57h0l-.73,6.8a2.7,2.7,0,1,1-5.37-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2057,754.8l.36-6.75v0a2.72,2.72,0,0,1,5.43.29h0l-.37,6.83a2.71,2.71,0,0,1-5.41-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2057.84,732.28l0-6.76v0a2.73,2.73,0,0,1,5.46,0h0l0,6.84a2.73,2.73,0,0,1-5.45,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2057.53,709.75l-.3-6.76v0a2.74,2.74,0,1,1,5.47-.24h0l.3,6.83a2.74,2.74,0,1,1-5.47.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2056.14,687.26l-.63-6.74v0A2.75,2.75,0,0,1,2061,680h0l.63,6.81a2.75,2.75,0,0,1-5.48.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2053.68,664.85l-.94-6.69v0a2.77,2.77,0,0,1,5.48-.77h0l.94,6.78a2.76,2.76,0,1,1-5.46.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2050.18,642.59l-1.26-6.65v0a2.77,2.77,0,1,1,5.45-1h0l1.26,6.72a2.77,2.77,0,1,1-5.45,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2045.65,620.51l-1.56-6.58v0a2.78,2.78,0,1,1,5.42-1.28h0l1.56,6.66a2.78,2.78,0,1,1-5.42,1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2040.12,598.66l-1.85-6.51v0a2.8,2.8,0,1,1,5.38-1.53h0l1.86,6.58a2.79,2.79,0,1,1-5.37,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2033.61,577.07l-2.13-6.41v0a2.81,2.81,0,0,1,5.33-1.77h0l2.15,6.49a2.8,2.8,0,1,1-5.32,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2026.17,555.79l-2.41-6.31,0,0a2.82,2.82,0,0,1,5.27-2h0l2.43,6.39a2.82,2.82,0,0,1-5.27,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2017.81,534.86l-2.68-6.21,0,0a2.83,2.83,0,0,1,5.2-2.24h0l2.7,6.28a2.83,2.83,0,0,1-5.2,2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2008.57,514.29l-3-6.09v0a2.84,2.84,0,1,1,5.12-2.48h0l3,6.15a2.84,2.84,0,1,1-5.12,2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1998.47,494.13l-3.19-6,0,0a2.85,2.85,0,1,1,5-2.69h0l3.21,6a2.85,2.85,0,0,1-5,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1987.54,474.4l-3.43-5.83,0,0a2.87,2.87,0,1,1,4.94-2.91h0l3.46,5.9a2.86,2.86,0,1,1-4.94,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1975.83,455.13l-3.67-5.69,0,0a2.88,2.88,0,1,1,4.84-3.12h0l3.69,5.75a2.88,2.88,0,0,1-4.84,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1963.35,436.34l-3.89-5.53,0,0a2.89,2.89,0,1,1,4.73-3.32h0l3.92,5.6a2.88,2.88,0,1,1-4.72,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1950.14,418.07l-4.11-5.38,0,0a2.9,2.9,0,0,1,4.62-3.52h0l4.14,5.44a2.9,2.9,0,0,1-4.62,3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1936.22,400.32l-4.3-5.22,0,0a2.92,2.92,0,0,1,4.5-3.71h0l4.34,5.27a2.91,2.91,0,1,1-4.49,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1921.63,383.12l-4.5-5.06,0,0a2.93,2.93,0,0,1,4.37-3.89h0l4.54,5.1a2.93,2.93,0,0,1-4.37,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1906.4,366.48l-4.69-4.88,0,0a2.94,2.94,0,1,1,4.23-4.07h0l4.74,4.93a2.94,2.94,0,0,1-4.24,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1890.56,350.42l-4.87-4.7,0,0a2.95,2.95,0,0,1,4.1-4.24h0l4.91,4.75a2.94,2.94,0,0,1-4.09,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1874.12,335l-5-4.52,0,0a3,3,0,1,1,4-4.4h0l5.08,4.57a3,3,0,0,1-3.95,4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1857.15,320.11l-5.2-4.34,0,0a3,3,0,1,1,3.81-4.56h0l5.24,4.38a3,3,0,0,1-3.81,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1839.66,305.85l-5.34-4.16,0,0A3,3,0,0,1,1838,297h0l5.39,4.2a3,3,0,0,1-3.67,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1821.7,292.19l-5.48-4,0,0a3,3,0,1,1,3.52-4.84h0l5.52,4a3,3,0,1,1-3.52,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1803.29,279.13l-5.6-3.8,0,0a3,3,0,1,1,3.38-5h0l5.65,3.84a3,3,0,1,1-3.38,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1784.47,266.66l-5.72-3.62,0,0a3,3,0,1,1,3.23-5.1h0l5.77,3.66a3,3,0,1,1-3.24,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1765.27,254.79l-5.83-3.45h0a3,3,0,0,1,3.08-5.22h0l5.88,3.48a3,3,0,1,1-3.09,5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1745.72,243.51l-5.93-3.27,0,0a3,3,0,1,1,2.94-5.32h0l6,3.3a3,3,0,1,1-2.94,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1725.83,232.82l-6-3.1h0a3.05,3.05,0,0,1,2.79-5.43h0l6.07,3.12a3.05,3.05,0,1,1-2.79,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1705.64,222.71l-6.11-2.92h0a3.06,3.06,0,0,1,2.64-5.53h0l6.16,2.95a3.06,3.06,0,1,1-2.64,5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1685.16,213.19l-6.19-2.74h0a3.07,3.07,0,0,1,2.49-5.62h0l6.24,2.77a3.07,3.07,0,1,1-2.5,5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1664.42,204.26l-6.26-2.57h0a3.09,3.09,0,1,1,2.34-5.71h0l6.32,2.59a3.09,3.09,0,0,1-2.34,5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1643.44,195.91l-6.33-2.39h0a3.1,3.1,0,0,1,2.19-5.8h0l6.39,2.41a3.1,3.1,0,0,1-2.19,5.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1622.24,188.15l-6.4-2.22h0a3.11,3.11,0,1,1,2-5.87h0l6.45,2.24a3.11,3.11,0,0,1-2,5.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1600.83,181l-6.46-2h0a3.12,3.12,0,0,1,1.87-5.95h0l6.5,2.06a3.12,3.12,0,1,1-1.88,5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1579.23,174.38l-6.51-1.87h0a3.14,3.14,0,1,1,1.73-6h0l6.56,1.89a3.13,3.13,0,1,1-1.73,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1557.46,168.37l-6.56-1.69h0a3.14,3.14,0,1,1,1.56-6.09h0l6.6,1.7a3.14,3.14,0,0,1-1.57,6.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1535.54,163l-6.61-1.51h0a3.16,3.16,0,0,1,1.41-6.16h0l6.65,1.52a3.15,3.15,0,1,1-1.41,6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1513.48,158.13l-6.65-1.33h0a3.17,3.17,0,0,1,1.24-6.21h0l6.69,1.35a3.16,3.16,0,1,1-1.25,6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1491.29,153.9l-6.67-1.15h0a3.18,3.18,0,0,1,1.08-6.26h0l6.72,1.17a3.17,3.17,0,1,1-1.08,6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1469,150.27l-6.7-1h0a3.19,3.19,0,1,1,.92-6.31h0l6.76,1a3.19,3.19,0,0,1-.92,6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1446.63,147.24l-6.11-.72h0a3.2,3.2,0,0,1,.75-6.36h0l6.15.73a3.2,3.2,0,0,1-.75,6.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1406.87 100.92 1411.46 142.44 1381.37 127.7 1406.87 100.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1217.51,97.76l123,85.94a10.57,10.57,0,0,0,15-2.94L1437.11,54a4.24,4.24,0,0,0-4.52-6.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1406.85 100.93 1217.51 97.76 1393.74 121.43 1395.51 132.89 1406.85 100.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1385.88 133.52 1411.46 142.44 1393.74 121.43 1385.88 133.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M475.34,1417s-2.7,14.43-4.08,28.74a9.86,9.86,0,0,0,9.33,10.78c19.06,1,59.82,2.91,74.46,2.39a3.21,3.21,0,0,0,2.87-4.37h0a7.17,7.17,0,0,0-3.64-3.9L487.21,1419Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M473.33,1408.45l1.88,17.32s11.75,5.6,19.87-.51l-4.7-19.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M478,1083.23c-.93,4.51-6.91,225.4,15.76,324.62a3.35,3.35,0,0,1-2,3.89,58.43,58.43,0,0,1-19.27,3.73,5.79,5.79,0,0,1-5.7-4.21c-6.53-23-37.78-138.43-40.95-248.41-3.54-122.89,0-4.18,0-4.18l3.49-75.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M397.77,1423.77s-4.13,7.26-8.25,26.63a6,6,0,0,0,5.22,7.26c6.29.67,16,1.56,23.74,1.58a6,6,0,0,0,6-6.63c-.79-7.09-3.36-18.74-11.55-27.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M394.42,1401.49l4.54,26.2s4.71,3.58,14.12,1.11l-2-28.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M384.44,1089.12c-20.43,116.38,1.44,288.13,9.05,321.77a5.23,5.23,0,0,0,4.18,4,35.25,35.25,0,0,0,15.12-.46,4.8,4.8,0,0,0,3.49-4.38c1.32-27.14,1-193.78,19.62-259.46a15,15,0,0,1,5.85-8.2l35.17-24.49L480,1077.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M509.61,869.44c-57.87-1.51-121.89,14-121.89,14-18.21,100.51-5.08,216.76-5.08,216.76,44.7,12.17,95.42-6.28,95.42-6.28,7.85-42,43.73-160.09,43.73-160.09,28.31-3.24,51.69-11.18,71-21.78-14.48-17.11-21.17-38.76-24-51.54C548.2,866.7,527.46,869.9,509.61,869.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M681.39,785.81a11.08,11.08,0,0,0-12.85-3.74c-8.86,35.9-53.79,64.65-99.81,78.47,2.87,12.78,9.56,34.43,24,51.54C669.32,870,681.39,785.81,681.39,785.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M680,787.55c.57,1.89-6.34,4.71-10.33-3.07-.1-3.71-2.21-19.61,0-22.61,11.95-16,35-35.92,35-35.92a5.44,5.44,0,0,1,.61,7.57L694.13,745c2.28,4.21,5.08,7.78,6.36,12.87a15.61,15.61,0,0,1-1.66,11.43c-2,3.49-4.69,8-7.23,11.57A15.37,15.37,0,0,1,680,787.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M689.2,752.43,679,760.91l-3.26,8.5,8.92,10.09s3.2-16.91,5.48-20.55S691.29,753.52,689.2,752.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M409.39,939.73l-21.67-56.26S333.31,919.69,324,966.18c10.2.85,28.77,3.68,46.87,13C375.06,957.27,409.39,939.73,409.39,939.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M456.13,992.91s-61,33.73-81.23,4.24c-4.19-6.12-5.15-12.17-4-17.93-18.1-9.36-36.67-12.19-46.87-13a64.28,64.28,0,0,0,6.56,44.13C365.79,1076.28,464,1008,464,1008Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M451.43,821.89,432.51,875a1.93,1.93,0,0,0,.85,2.32c5,2.82,23,11,44.93-2.59a9,9,0,0,0,4.23-6.42l6.4-46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M492,773s19.86,38.26,17.12,53.61-27.8,14-49.56,1.32l-14.9-41.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M460.7,807.7a1.57,1.57,0,0,0,.7-2.29c-1.59-2.49-4.58-7.57-5.51-12,0,0-3.61-2.36,9.31-5.33s32.18-7.56,36.33-18.5c4-10.65-6.06-37.65-22.77-16.38a1.57,1.57,0,0,1-2.49,0c-2.67-3.55-9.72-10.93-19.64-6.59-9.28,4.06-10.39,10.82-10.3,14.24a1.56,1.56,0,0,1-1.86,1.58c-4.66-.94-15.87-1.81-21.22,9.65-4.4,9.43-1.65,14.83.88,17.47a1.57,1.57,0,0,1-.7,2.59c-3.08.92-7.07,3.48-6.74,10.68.45,10,11.58,9.19,14.76,8.77a1.58,1.58,0,0,1,1.39.5c2.68,3,14.8,15.91,28,17.58a1.59,1.59,0,0,0,1.68-2.08L457,810.88a1.58,1.58,0,0,1,.87-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M463,810.08s-14.31-10-15.44-1.7,12.85,12.17,19.83,9.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M443.66,1046.21,476.9,930.12a3.4,3.4,0,0,1,2.87-2.44c6-.7,23.47-2.67,43.62-4.38,24.28-2,52.46-3.72,69.31-2.3a3.39,3.39,0,0,1,2.77,4.89c-9.57,19.38-49,98.2-68.7,124a3.44,3.44,0,0,1-2.75,1.34l-77.13-.72A3.39,3.39,0,0,1,443.66,1046.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M451.69,1018.16s-4.63-19-2.76-25.79,5.49-15.44,17.55-13.51,26.29,7,26.29,7-.71,8.8-9.88,6l5.68,4.4s-.81,7-8.55,3.28l5.28,5.83s-3.32,5.79-9,2.08S467.85,1020.46,451.69,1018.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M521.18,958a9.76,9.76,0,1,0,9.76-9.76A9.76,9.76,0,0,0,521.18,958Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M480.51,964.34l-2.18-.64,6.77-23a10.3,10.3,0,0,1,7.75-7.21c21.44-4.48,79.74-5.42,80.32-5.43l0,2.27c-.58,0-58.67,1-79.89,5.38a8,8,0,0,0-6,5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M336.29,1189.78h.3l128.63-.13a5.75,5.75,0,1,0,0-11.49l-128.62.12a5.75,5.75,0,0,0-.29,11.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M515,1063.82a2.1,2.1,0,0,0-.13.26l-54.12,116.69a5.74,5.74,0,1,0,10.42,4.83l54.12-116.69a5.74,5.74,0,0,0-10.29-5.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 838.27,
    y: 1307.05,
    width: 13.58,
    height: 146.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M904.51,1456.69H785.61a8.83,8.83,0,0,1,8.84-8.83H895.68a8.83,8.83,0,0,1,8.83,8.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 772.66,
    y: 1274.15,
    width: 149.5,
    height: 42.4,
    rx: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M744.84,1209.16s-20.17,3.13-42.86,18.29a11.31,11.31,0,0,0-5,10.8c2.72,21.52,13.89,91.15,50.71,159.15a17.12,17.12,0,0,1,1.64,11.75L743,1438.92l-11.87,11.13h30.56L782,1395l-8.7-2.75a16.47,16.47,0,0,1-11.5-15.42l-1-59.06c.87-26.32-16.14-44.47-16.14-44.47l48.81-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M719.15,1455.42c-2.78,3.64,30,8.45,46.49.48,0,0,22.93-39.89,22.93-60.43,0,0-1.82-4.18-15.28-3.23,0,0-7.7,47.23-15.83,52.52s-22.74.53-22.74.53S723.26,1450,719.15,1455.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M787.26,1274.15c-.26-.45-52.54-6.28-52.54-6.28s1.71,15.89-3.64,37.78S649,1422.34,649,1422.34l8,25.52c-24.89,8.67-49.37,10.05-73.45,4.42l49.88-29.94s46.68-159.09,75.28-187.47l52.4-18.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M904.51,1181.59s30.13,44.8,32.6,65.24-8.25,28.74-39.86,30.11-116,1.35-116,1.35l-72-61.55s52.48-18.73,66.13-24S904.51,1181.59,904.51,1181.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M654,1439.26s8.66,8.4,2.81,17.74c0,0-68.65,12.16-87.28,6.64,0,0,3.87-8.83,24.85-18.88l-1.54,1.18a2.51,2.51,0,0,0,1.65,4.5C608.3,1449.65,636.92,1447.12,654,1439.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M774,897.45c61.58-10.47,90.57,39.75,88.45,50.3A1.93,1.93,0,0,0,864.9,950c7.06-1.9,22.68-4.3,32.36,7.83,8.55,10.71,2.16,20.82-3,26.37a1.94,1.94,0,0,0,1.63,3.28c13-1.64,41.24-2,45.86,24.42,4.31,24.68-12.87,31.63-23.05,33.59A1.93,1.93,0,0,0,918,1049c5.08,3.22,11,9.88,8.58,23-3.72,20.6-44.12,18.91-48.84,18.65a2,2,0,0,1-.84-.26l-64.69-36.89a2,2,0,0,1-1-1.36L798.2,976.73a2,2,0,0,1,.52-1.68l-42.18-59.52C741.23,913.27,773.31,897.57,774,897.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M823.05,1175.65s-35.08-33.4-52.35-55.52a46.94,46.94,0,0,1-7.94-42.25c7.88-26.55,21.89-54.06,23.17-58.34,2-6.57,41.29-6.29,41.29-6.29s77.39,50.23,107.8,135.32l-34.15,10.63s-20.21-33.9-40.17-55.46c0,0,34.55,45.64,35.76,64.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M781.17,982.86c.41,1.37,10.68,35.4,11.48,36.1s22.51,1.88,32.73-5.11L800,964.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M740,939.13s-5,19.5,8.76,45.72,29.27,26.19,37.76,17.8,19-22.64,16.48-48S747.18,914.33,740,939.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M784,956s-22.77-34.81-44.13-7.41l-.38,10s-25-3-20.64-25.9,26-37.27,53.84-27.34,43.78,20.13,45.58,40.07S804.23,961,804.23,961s-5.18-14-12.54-15.51-5.45,9.5-5.45,9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M790.87,959.57s-11.82-17.82.29-20.48,10.22,17.37,8.92,24.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M751.59,1178.13l25.77-24.84L813,1168.35s35.49,5.5,55.8,0l20.31-5.49,45.9-14.29,7.21,20.37a12.27,12.27,0,0,1-4.48,14.09c-4,2.82-8.62,5.93-11.59,7.22-6,2.65-149-1.83-149-1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M849.12,1189.85h-.34l-149.51-.16a6.69,6.69,0,1,1,0-13.38l149.5.16a6.69,6.69,0,0,1,.33,13.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M564.88,1054.11h124.5a23.73,23.73,0,0,1,21.47,13.61l57.56,122H613.68a14.41,14.41,0,0,1-13.41-9.13L555.63,1067.7A9.94,9.94,0,0,1,564.88,1054.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M652.59,1116.69c2.7,8.38.71,16.52-4.45,18.18s-11.52-3.79-14.22-12.17-.71-16.53,4.45-18.19S649.9,1108.3,652.59,1116.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M271,1468.42a4.44,4.44,0,0,1-1.92-.44,5.47,5.47,0,0,1-2.53-6.94l101.59-257.76a4.7,4.7,0,0,1,6.36-2.77,5.49,5.49,0,0,1,2.54,7L275.42,1465.22A4.86,4.86,0,0,1,271,1468.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M385.41,1468.42a4.85,4.85,0,0,1-4.45-3.2L279.37,1207.46a5.48,5.48,0,0,1,2.53-7,4.71,4.71,0,0,1,6.37,2.77L389.86,1461a5.48,5.48,0,0,1-2.54,6.94A4.37,4.37,0,0,1,385.41,1468.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M960.42,1468.42a4.44,4.44,0,0,1-1.92-.44A5.47,5.47,0,0,1,956,1461l101.59-257.76a4.7,4.7,0,0,1,6.36-2.77,5.49,5.49,0,0,1,2.54,7L964.87,1465.22A4.86,4.86,0,0,1,960.42,1468.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1074.86,1468.42a4.85,4.85,0,0,1-4.45-3.2L968.82,1207.46a5.48,5.48,0,0,1,2.53-7,4.71,4.71,0,0,1,6.37,2.77L1079.31,1461a5.48,5.48,0,0,1-2.54,6.94A4.37,4.37,0,0,1,1074.86,1468.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M945.68,1185.07h147.13v-15.18H945.68C948.83,1169.89,948.83,1185.07,945.68,1185.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1091.81,1185.07a1,1,0,0,0,1-1v-13.18a1,1,0,0,0-1-1H942.19a1,1,0,0,1-1-1v-1.44a1,1,0,0,1,1-1h159a6.35,6.35,0,0,1,6.35,6.36v9.7a6,6,0,0,1-6,6H942.19a1,1,0,0,1-1-1v-1.43a1,1,0,0,1,1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1114.14,1195.31a4.48,4.48,0,0,0-1.84-4.78,10.91,10.91,0,0,0-6.72-2.11H224a12,12,0,0,0-8.46,3.07,4.8,4.8,0,0,0-.65,6.38l9.55,13.72c2.19,3.14,6.93,5.15,12.15,5.15h863c4.85,0,9-2.28,9.94-5.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1921.32,1150.53l32-22a18.11,18.11,0,0,1,10.47-3.17l7,.09s34.47,218.88,30.22,311.74c-.37,8.21-2.3,33-2.3,33s-4.23.51-8.81.88a23.71,23.71,0,0,1-13.55-3l-45.78-25.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2084.74,1128.09l-118.9-2.59a7.08,7.08,0,0,0-7.22,7.58l23,328.32a10.72,10.72,0,0,0,8.3,9.7h0l107.63-4.63a6,6,0,0,0,5.69-5.64c1.82-34,10.53-220.8-10.87-326.35A8,8,0,0,0,2084.74,1128.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1980.18,1158l.14,2.74a3.82,3.82,0,0,0,3.76,3.64l92.23,1.53a3.83,3.83,0,0,0,3.89-3.83V1157a3.82,3.82,0,0,0-3.86-3.82L1984,1154A3.82,3.82,0,0,0,1980.18,1158Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1983.78,1199.23l.65,5.94a3.83,3.83,0,0,0,3.86,3.42l89.43-1.44a3.84,3.84,0,0,0,3.77-3.83v-5.65a3.83,3.83,0,0,0-3.88-3.83l-90.07,1.15A3.83,3.83,0,0,0,1983.78,1199.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1985.36,1241.78l.16,1.15a3.82,3.82,0,0,0,3.88,3.31l88.33-2.1a3.82,3.82,0,0,0,3.68-4.45l-.65-3.94a3.82,3.82,0,0,0-4-3.2l-87.83,4.89A3.83,3.83,0,0,0,1985.36,1241.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1989.1,1280.44h0a3.82,3.82,0,0,0,3.8,3.37h88a3.83,3.83,0,0,0,3.83-3.82v-1.8a3.84,3.84,0,0,0-3.91-3.83l-88,1.8A3.83,3.83,0,0,0,1989.1,1280.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1995.7,1321l9.52,128.4a3.83,3.83,0,0,0,4.09,3.53l73.62-5.25a3.82,3.82,0,0,0,3.56-3.87l-1.74-123.15a3.82,3.82,0,0,0-3.83-3.77h-81.4A3.83,3.83,0,0,0,1995.7,1321Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M2074.77,1428.22a3.4,3.4,0,0,1-3.4-3.4v-87.89a5.34,5.34,0,0,0-5.35-5.35h0c-52.73.24-53.71,0-54.35-.13a3.4,3.4,0,0,1,1.24-6.68c2.06.14,21.85.15,53.08,0a12.36,12.36,0,0,1,8.63,3.54,12.08,12.08,0,0,1,3.58,8.62v87.89A3.4,3.4,0,0,1,2074.77,1428.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M2082.12,1308.84h-85.46a9.33,9.33,0,0,1-9.22-8.09c-8.34-63-13.2-111.5-15.3-152.52a9.31,9.31,0,0,1,9.53-9.78l97.48,2.48a9.29,9.29,0,0,1,9.07,9.1l3.2,149.3a9.31,9.31,0,0,1-9.3,9.51Zm-100.69-163.59a2.51,2.51,0,0,0-2.5,2.63c2.09,40.84,6.93,89.13,15.25,152a2.51,2.51,0,0,0,2.48,2.17h85.46a2.49,2.49,0,0,0,2.5-2.55l-3.2-149.31a2.5,2.5,0,0,0-2.44-2.44l-97.48-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M2080.21,1182.78h-.06l-99.44-1.57a3.4,3.4,0,0,1,.1-6.8l99.45,1.57a3.4,3.4,0,0,1-.05,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M2080.2,1226.7h-91.13a3.4,3.4,0,1,1,0-6.8h91.13a3.4,3.4,0,1,1,0,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M2018.81,1266c-27.19,0-27.9-.23-28.32-.36a3.4,3.4,0,0,1,1.54-6.6c3.73.27,55.37.13,89.42,0h0a3.4,3.4,0,1,1,0,6.8C2052.07,1266,2032.22,1266,2018.81,1266Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1455.17,1157.67l-32-22a18.11,18.11,0,0,0-10.47-3.17l-7,.09s-34.47,218.88-30.22,311.75c.37,8.2,2.3,33,2.3,33s4.23.5,8.81.87a23.62,23.62,0,0,0,13.55-3l45.78-25.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1291.75,1135.23l118.9-2.59a7.08,7.08,0,0,1,7.22,7.58l-23,328.32a10.71,10.71,0,0,1-8.3,9.7h0l-107.63-4.63a6,6,0,0,1-5.69-5.63c-1.82-34-10.53-220.8,10.87-326.35A8,8,0,0,1,1291.75,1135.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1396.31,1165.18l-.14,2.75a3.82,3.82,0,0,1-3.76,3.63l-92.23,1.53a3.82,3.82,0,0,1-3.89-3.83v-5.08a3.82,3.82,0,0,1,3.86-3.83l92.37.81A3.83,3.83,0,0,1,1396.31,1165.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1392.71,1206.38l-.65,5.94a3.83,3.83,0,0,1-3.86,3.41l-89.43-1.44a3.83,3.83,0,0,1-3.77-3.83v-5.65a3.84,3.84,0,0,1,3.88-3.83l90.07,1.16A3.83,3.83,0,0,1,1392.71,1206.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1391.13,1248.92l-.16,1.15a3.84,3.84,0,0,1-3.88,3.32l-88.33-2.1a3.83,3.83,0,0,1-3.68-4.45l.65-3.94a3.82,3.82,0,0,1,4-3.2l87.83,4.89A3.82,3.82,0,0,1,1391.13,1248.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1387.39,1287.59h0a3.83,3.83,0,0,1-3.8,3.37h-88a3.84,3.84,0,0,1-3.83-3.83v-1.8a3.83,3.83,0,0,1,3.91-3.82l88,1.79A3.83,3.83,0,0,1,1387.39,1287.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1380.79,1328.16l-9.52,128.4a3.83,3.83,0,0,1-4.09,3.54l-73.62-5.26A3.82,3.82,0,0,1,1290,1451l1.74-123.14a3.83,3.83,0,0,1,3.83-3.78H1377A3.83,3.83,0,0,1,1380.79,1328.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1301.72,1435.37a3.4,3.4,0,0,1-3.4-3.4v-87.9a12.15,12.15,0,0,1,12.15-12.15h0c31.24.14,51,.14,53.09,0a3.4,3.4,0,0,1,1.23,6.68c-.63.15-1.6.37-54.35.13a5.36,5.36,0,0,0-5.37,5.35V1432A3.4,3.4,0,0,1,1301.72,1435.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1379.83,1316h-85.46a9.31,9.31,0,0,1-9.3-9.5l3.2-149.31a9.3,9.3,0,0,1,9.07-9.1l97.48-2.47a9.29,9.29,0,0,1,9.53,9.77c-2.1,41-7,89.5-15.3,152.53A9.34,9.34,0,0,1,1379.83,1316Zm15.23-163.58H1395l-97.48,2.47a2.51,2.51,0,0,0-2.44,2.45l-3.2,149.3a2.49,2.49,0,0,0,2.5,2.56h85.46a2.52,2.52,0,0,0,2.48-2.18c8.31-62.83,13.16-111.13,15.25-152a2.51,2.51,0,0,0-.71-1.87A2.47,2.47,0,0,0,1395.06,1152.4Zm-.15-3.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1296.28,1189.92a3.4,3.4,0,0,1,0-6.8l99.45-1.57a3.4,3.4,0,1,1,.1,6.8l-99.44,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1387.42,1233.84h-91.14a3.4,3.4,0,0,1,0-6.8h91.14a3.4,3.4,0,0,1,0,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1357.68,1273.18c-13.41,0-33.25,0-62.67-.2a3.4,3.4,0,1,1,0-6.8h0c34.06.17,85.69.32,89.42,0a3.4,3.4,0,0,1,1.54,6.61C1385.58,1273,1384.86,1273.18,1357.68,1273.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1464.67,
    y: 1060.94,
    width: 444.31,
    height: 371.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1925.63,1011.27l-478.54,3c-6.49,0-11.74,4.79-11.74,10.61v71.42c0,5.6,5.06,10.17,11.31,10.21l479,3c7.11,0,12.88-4.77,12.88-10.76V1022C1938.51,1016,1932.74,1011.22,1925.63,1011.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1925.63,1011.27l-479,3c-6.25,0-11.31,4.62-11.31,10.22l503.16-2.47C1938.51,1016,1932.74,1011.22,1925.63,1011.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1446.66,1106.52l479,3c7.11,0,12.88-4.77,12.88-10.76l-503.16-2.47C1435.35,1101.91,1440.41,1106.48,1446.66,1106.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1926,1130.35l-478.91-1c-6.69,0-12.18,4.83-12.25,10.83l-.89,73.71c-.07,5.8,5.11,10.54,11.57,10.6l480.45,4.2c6.91.06,12.52-4.75,12.52-10.75V1141.2C1938.51,1135.22,1932.91,1130.37,1926,1130.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1926,1130.35l-479.36-1c-6.45,0-11.73,4.65-11.8,10.43l503.65,1.41C1938.51,1135.22,1932.91,1130.37,1926,1130.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1445.54,1224.5l480.45,4.2c6.91.06,12.52-4.75,12.52-10.75l-504.54-4C1433.9,1219.7,1439.08,1224.44,1445.54,1224.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1926.44,1249.76H1447.88c-6.92,0-12.53,5-12.53,11.26v76.33c0,6,5.4,10.84,12.07,10.84h479c6.67,0,12.07-4.85,12.07-10.84v-76.74C1938.51,1254.62,1933.11,1249.76,1926.44,1249.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1926.44,1249.76h-479c-6.67,0-12.07,4.86-12.07,10.85h503.16C1938.51,1254.62,1933.11,1249.76,1926.44,1249.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1447.42,1348.19h479c6.67,0,12.07-4.85,12.07-10.84H1435.35C1435.35,1343.34,1440.75,1348.19,1447.42,1348.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1927,1371l-478.84-1.88c-7,0-12.76,5-12.76,11.22v76.33c0,6,5.5,10.84,12.28,10.84l479.05.19c6.55,0,11.87-4.76,11.89-10.64l.21-75.36C1938.8,1375.8,1933.5,1371,1927,1371Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1927,1371l-479.31-1.88c-6.79,0-12.29,4.81-12.29,10.8l503.43,1.78C1938.8,1375.8,1933.5,1371,1927,1371Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1447.63,1467.49l479.05.19c6.55,0,11.87-4.76,11.89-10.64l-503.22-.39C1435.35,1462.63,1440.85,1467.49,1447.63,1467.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1973.33,162.82a2.14,2.14,0,0,1-2.1-2.11c-.22-11.81-3.9-70.48-55.57-82.74-57.53-13.65-83.85,44.85-83.85,44.85s-71.17-27.3-84.82,45.82c-44.63,10.71-56.23,69-27.2,97.47a24.92,24.92,0,0,0,17.25,7.14l279.49,2.52a18.41,18.41,0,0,0,17.81-13.16C2043.07,233.14,2054.51,164.73,1973.33,162.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1966.94,164.08a2.16,2.16,0,0,1-2.1-2.11c-.23-11.33-3.88-65.73-52.54-77.14-54.39-12.75-79.29,41.88-79.29,41.88s-67.3-25.49-80.2,42.8c-41.8,9.9-53,63.38-26.5,90.25a25,25,0,0,0,17.56,7.44l263.1,2.34a18.39,18.39,0,0,0,17.82-13.21C2033,228.35,2042.73,165.89,1966.94,164.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1676.42,315.34a1.31,1.31,0,0,1-1.27-1.28c-.13-7.13-2.35-42.55-33.55-50-34.73-8.24-50.63,27.08-50.63,27.08s-43-16.48-51.21,27.67c-27,6.47-34,41.66-16.42,58.85a15,15,0,0,0,10.42,4.31l168.75,1.52a11.1,11.1,0,0,0,10.75-7.94C1718.53,357.8,1725.44,316.49,1676.42,315.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1672.57,316.1a1.3,1.3,0,0,1-1.27-1.28c-.14-6.84-2.34-39.69-31.73-46.57-32.84-7.7-47.87,25.29-47.87,25.29s-40.63-15.4-48.43,25.83c-25.23,6-32,38.28-16,54.5a15,15,0,0,0,10.6,4.49l158.86,1.41a11.11,11.11,0,0,0,10.76-8C1712.45,354.9,1718.33,317.19,1672.57,316.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1849.35,287.19h-52.53l9.26-77.46-23.3-2.83,38.44-56.55,38.29,58.75h-18.82Zm-48.47-3.61h44.44l-8.66-78.08h16.2l-31.7-48.64L1789.08,204l21,2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1903,270.51l-38.33-57.8h18.85l-8.66-78.09h52.53l-9.26,76.53,23.3,2.83Zm-31.62-54.2L1903,264.05l32.09-47.2-21-2.55,9.2-76.07h-44.43l8.66,78.08Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication1);
export default __webpack_public_path__ + "static/media/application_1.52ab6f0b508740c2a0e274595d2e0530.svg";
export { ForwardRef as ReactComponent };